<template>
  <div>
    <v-row>
      <v-col cols="12">
        <!-- <v-card-title>
          <v-spacer></v-spacer>
          <v-text-field v-model="filter" append-icon="search" label="Search" single-line hide-details></v-text-field>
        </v-card-title> -->

        <div class="d-flex mb-5 justify-center" v-if="!viewHandle">
          <div>
            <v-text-field
            style="min-width:300px"
            v-model="handle"
            prefix="@"
            label="Enter Handle"
            outlined
            hide-details
            @keyup.enter="changeHandle(handle, 0)">
            </v-text-field>
          </div>
          <!-- <div class="ml-2">
            <v-text-field
            v-model="compareHandle"
            prefix="@"
            label="Handle Two"
            outlined
            hide-details
            @keyup.enter="changeHandle(compareHandle, 1)">
            </v-text-field>
          </div> -->
        </div>
        <!-- <v-alert class="mt-5" color="warning" type="warning" icon="warning" v-if="!creators.length">
          <p class="mb-1" style="color: #fff">
            Empty Data
          </p>
        </v-alert> -->
        <div class="mb-5 pb-5">
          <div class="d-flex" style="justify-content:space-between">
            <div class="h4 mb-2">Post Analysis Summary</div>
            <div style="margin-top:-5px" class="text-right">
              <v-menu
                :close-on-content-click="false"
                bottom
                left
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    color="secondary"
                    v-bind="attrs"
                    v-on="on"
                    @click="openColSettingsModal('post')"
                  >
                    <i class="fas fa-cog fa-lg" data-toggle="tooltip" data-placement="top" title="Settings"></i>
                  </v-btn>
                </template>
              </v-menu>
            </div>
          </div>
          <v-row class="no-gutters">
            <v-col cols="12" sm="12" md="12" lg="12">
              <v-row class="action-section mb-0 mt-2 ml-1">
                <v-col class="action-group-section pl-0" cols="12" sm="3" md="3" lg="3">
                  <div class="d-flex flex-row" style="gap:3px">
                    <div>
                      <v-btn
                        class="mb-2"
                        color="warning"
                        small
                        v-if="selectedPostAnalysis && selectedPostAnalysis.length > 0"
                        @click="openPostAnalysisAvgModal()"
                      >Calculate Average ({{selectedPostAnalysis.length}})</v-btn>
                    </div>
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <!-- BEGIN vue data table -->
          <v-data-table 
          :headers="computedPostTableHeaders" 
          :search="filter" 
          :items="postAnalysisData" 
          show-select
          :single-select="false"
          v-model="selectedPostAnalysis"
          class="statistics-analysis-table elevation-1">
            <template v-for="(h, index) in computedPostTableHeaders" v-slot:[`header.${h.value}`]="{ header }">
              <legend-icon :key="index" :header="h" rootClass="legend-row" />
            </template>
            <template v-slot:item.contents="{ item }">
              <td class="text-left" style="min-width:180px">
                <span v-if="item.campaign">{{item.campaign.name}}</span>
              </td>
            </template>
            <template v-slot:[`item.url`]="{ item }">
              <td class="text-left">
                <v-btn
                  x-small
                  text
                  color="secondary"
                  elevation="0"
                  :href="item.url"
                  :target="'_blank'"
                >
                  View
                </v-btn>
              </td>
            </template>
            <template v-slot:item.outreach="{ item }">
              {{item.outreach === 0 ? '-' : item.outreach | thousandSeprator}}
            </template>
            <template v-slot:item.likes="{ item }">
              {{item.likes === 0 ? '-' : item.likes | thousandSeprator}}
            </template>
            <template v-slot:item.comments="{ item }">
              {{item.comments === 0 ? '-' : item.comments | thousandSeprator}}
            </template>
            <template v-slot:item.saved="{ item }">
              {{item.saved === 0 ? '-' : item.saved | thousandSeprator}}
            </template>
            <template v-slot:item.shares="{ item }">
              {{item.shares === 0 ? '-' : item.shares}}
            </template>
            <template v-slot:item.views="{ item }">
              {{item.views === 0 ? '-' : item.views}}
            </template>
            <template v-slot:item.reach="{ item }">
              {{item.reach === 0 ? '-' : item.reach}}
            </template>
            <template v-slot:item.impressions="{ item }">
              {{item.impressions === 0 ? '-' : item.impressions}}
            </template>
            <template v-slot:item.new_engagement_rate="{ item }">
              <div>
                {{item.new_engagement_rate === 0 ? '0' : item.new_engagement_rate}} %
              </div>
            </template>
            <template v-slot:item.new_engagement_rate_view="{ item }">
              <div>
                {{item.new_engagement_rate_view === 0 || !item.new_engagement_rate_view ? '-' : item.new_engagement_rate_view + '%'}}
              </div>
            </template>
            <template v-slot:item.engagement_rate_reach="{ item }">
              <div>
                {{item.engagement_rate_reach === 0 || item.engagement_rate_reach == 'Infinity' ? '-' : item.engagement_rate_reach + '%'}}
              </div>
            </template>
            <template v-slot:item.engagement_rate_sd="{ item }">
              <div v-if="item.engagement_rate_sd && item.engagement_rate_sd !== '0.00'">
                {{item.engagement_rate_sd === null ? '-' : item.engagement_rate_sd + '%'}}
              </div>
              <div v-else>
                <v-icon small data-toggle="tooltip" data-placement="top" title="Hidden">mdi-eye-off</v-icon>
              </div>
            </template>
            <template v-slot:item.median_engagement_rate="{ item }">
              {{item.median_engagement_rate === null || item.median_engagement_rate === 0 ? '-' : item.median_engagement_rate + '%'}}
            </template>
            <template v-slot:item.avg_likes="{ item }">
              {{item.avg_likes === null || item.median_engagement_rate === 0 ? '-' : item.avg_likes | thousandSeprator}}
            </template>
            <template v-slot:item.avg_comments="{ item }">
              {{item.avg_comments === null || item.median_engagement_rate === 0 ? '-' : item.avg_comments | thousandSeprator}}
            </template>
            <template v-slot:item.avg_views="{ item }">
              {{item.avg_views === null || item.median_engagement_rate === 0 ? '-' : item.avg_views | thousandSeprator}}
            </template>
            <template slot="body.append">
              <tr style="font-weight:500;">
                <td><strong>AVERAGE</strong></td>
                <td v-show="postColStatuses.contents"><strong>-</strong></td>
                <td v-show="postColStatuses.live_date"><strong>-</strong></td>
                <td v-show="postColStatuses.url"><strong>-</strong></td>
                <td v-show="postColStatuses.outreach"><strong>{{calPostTotal('totalOutreach') === 0 ? '-' : calPostTotal('totalOutreach')  | thousandSeprator}}</strong></td>
                <td v-show="postColStatuses.reach"><strong>{{calPostTotal('totalReach') === 0 ? '-' : calPostTotal('totalReach')  | thousandSeprator}}</strong></td>
                <td v-show="postColStatuses.impressions"><strong>{{calPostTotal('totalImpressions') === 0 ? '-' : calPostTotal('totalImpressions')  | thousandSeprator}}</strong></td>
                <td v-show="postColStatuses.likes"><strong>{{calPostTotal('totalLikes') === 0 ? '-' : calPostTotal('totalLikes')  | thousandSeprator}}</strong></td>
                <td v-show="postColStatuses.shares"><strong>{{calPostTotal('totalShares') === 0 ? '-' : calPostTotal('totalShares')  | thousandSeprator}}</strong></td>
                <td v-show="postColStatuses.comments"><strong>{{calPostTotal('totalComments') === 0 ? '-' : calPostTotal('totalComments')  | thousandSeprator}}</strong></td>
                <td v-show="postColStatuses.saved"><strong>{{calPostTotal('totalSaved') === 0 ? '-' : calPostTotal('totalSaved')  | thousandSeprator}}</strong></td>
                <td v-show="postColStatuses.interactions"><strong>{{calPostTotal('totalInteractions') === 0 ? '-' : calPostTotal('totalInteractions')  | thousandSeprator}}</strong></td>
                <td v-show="postColStatuses.views"><strong>{{calPostTotal('totalViews') === 0 ? '-' : calPostTotal('totalViews')  | thousandSeprator}}</strong></td>
                <td v-show="postColStatuses.new_engagement_rate"><strong>{{calPostTotal('totalEngagementRate') === 0 ? '-' : calPostTotal('totalEngagementRate') + '%'}}</strong></td>
                <td v-show="postColStatuses.new_engagement_rate_view"><strong>{{calPostTotal('totalEngagementRateView') === 0 ? '-' : calPostTotal('totalEngagementRateView') + '%'}}</strong></td>
                <td v-show="postColStatuses.engagement_rate_reach"><strong>{{calPostTotal('totalEngagementRateReach') === 0 || calPostTotal('totalEngagementRateReach') == 'Infinity' ? '-' : calPostTotal('totalEngagementRateReach') + '%'}}</strong></td>
                <td v-show="postColStatuses.engagement_rate_sd"><strong> {{calPostTotal('totalEngRateSd') === 0 ? '-' : calPostTotal('totalEngRateSd') + '%'}}</strong></td>
                <td v-show="postColStatuses.median_engagement_rate"><strong> {{calPostTotal('totalMedianEngRate') === 0 ? '-' : calPostTotal('totalMedianEngRate')}}</strong></td>
                <td v-show="postColStatuses.avg_likes"><strong> {{calPostTotal('totalAvgLikes') === 0 ? '-' : calPostTotal('totalAvgLikes')}}</strong></td>
                <td v-show="postColStatuses.avg_comments"><strong> {{calPostTotal('totalAvgComments') === 0 ? '-' : calPostTotal('totalAvgComments')}}</strong></td>
                <td v-show="postColStatuses.avg_views"><strong> {{calPostTotal('totalAvgViews') === 0 ? '-' : calPostTotal('totalAvgViews')}}</strong></td>
              </tr>
            </template>
            <template v-slot:no-data>No Data</template>
          </v-data-table>
        </div>

        <div class="mb-5 pb-5">
          <div class="d-flex" style="justify-content:space-between">
            <div class="h4 mb-2">Story Analysis Summary</div>
            <div style="margin-top:-5px" class="text-right">
              <v-menu
                :close-on-content-click="false"
                bottom
                left
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    color="secondary"
                    v-bind="attrs"
                    v-on="on"
                    @click="openColSettingsModal('story')"
                  >
                    <i class="fas fa-cog fa-lg" data-toggle="tooltip" data-placement="top" title="Settings"></i>
                  </v-btn>
                </template>
              </v-menu>
            </div>
          </div>
          <v-row class="no-gutters">
            <v-col cols="12" sm="12" md="12" lg="12">
              <v-row class="action-section mb-0 mt-2 ml-1">
                <v-col class="action-group-section pl-0" cols="12" sm="3" md="3" lg="3">
                  <div class="d-flex flex-row" style="gap:3px">
                    <div>
                      <v-btn
                        class="mb-2"
                        color="warning"
                        small
                        v-if="selectedStoryAnalysis && selectedStoryAnalysis.length > 0"
                        @click="openStoryAnalysisAvgModal()"
                      >Calculate Average ({{selectedStoryAnalysis.length}})</v-btn>
                    </div>
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <!-- BEGIN vue data table -->
          <v-data-table
          :headers="computedStoryTableHeaders" 
          :search="filter" 
          :items="storyAnalysisData"
          show-select
          :single-select="false"
          v-model="selectedStoryAnalysis"
          class="statistics-analysis-table elevation-1">
            <template v-for="(h, index) in computedStoryTableHeaders" v-slot:[`header.${h.value}`]="{ header }">
              <legend-icon :key="index" :header="h" rootClass="legend-row" />
            </template>
            <template v-slot:item.contents="{ item }">
              <td class="text-left" style="min-width:180px">
                <span v-if="item.campaign">{{item.campaign.name}}</span>
              </td>
            </template>
            <template v-slot:item.outreach="{ item }">
              {{item.outreach === 0 || !item.outreach ? '-' : item.outreach | thousandSeprator}}
            </template>
            <template v-slot:item.shares="{ item }">
              {{item.shares === 0 ? '-' : item.shares | thousandSeprator}}
            </template>
            <template v-slot:item.replies="{ item }">
              {{item.replies === 0 ? '-' : item.replies | thousandSeprator}}
            </template>
            <template v-slot:item.link_clicks="{ item }">
              {{item.link_clicks === 0 ? '-' : item.link_clicks | thousandSeprator}}
            </template>
            <template v-slot:item.sticker_taps="{ item }">
              {{item.sticker_taps === 0 ? '-' : item.sticker_taps | thousandSeprator}}
            </template>
            <template v-slot:item.reach="{ item }">
              {{item.reach === 0 ? '-' : item.reach | thousandSeprator}}
            </template>
            <template v-slot:item.impressions="{ item }">
              {{item.impressions === 0 ? '-' : item.impressions | thousandSeprator}}
            </template>
            <template v-slot:item.avg_views="{ item }">
              {{item.avg_views === null ? '-' : item.avg_views | thousandSeprator}}
            </template>
            <template v-slot:item.avg_reels_plays="{ item }">
              {{item.avg_reels_plays === null ? '-' : item.avg_reels_plays | thousandSeprator}}
            </template>
            <template slot="body.append">
              <tr style="font-weight:500;">
                <td><strong>AVERAGE</strong></td>
                <td v-if="storyColStatuses.contents"><strong>-</strong></td>
                <td v-if="storyColStatuses.live_date"><strong>-</strong></td>
                <td v-if="storyColStatuses.outreach">
                  <strong>{{ calStoryTotal('totalOutreach') === 0 ? '-' : calStoryTotal('totalOutreach') | thousandSeprator }}</strong>
                </td>
                <td v-if="storyColStatuses.reach">
                  <strong>{{ calStoryTotal('totalReach') === 0 ? '-' : calStoryTotal('totalReach') | thousandSeprator }}</strong>
                </td>
                <td v-if="storyColStatuses.impressions">
                  <strong>{{ calStoryTotal('totalImpressions') === 0 ? '-' : calStoryTotal('totalImpressions') | thousandSeprator }}</strong>
                </td>
                <td v-if="storyColStatuses.replies">
                  <strong>{{ calStoryTotal('totalReplies') === 0 ? '-' : calStoryTotal('totalReplies') | thousandSeprator }}</strong>
                </td>
                <td v-if="storyColStatuses.shares">
                  <strong>{{ calStoryTotal('totalShares') === 0 ? '-' : calStoryTotal('totalShares') | thousandSeprator }}</strong>
                </td>
                <td v-if="storyColStatuses.link_clicks">
                  <strong>{{ calStoryTotal('totalLinkClicks') === 0 ? '-' : calStoryTotal('totalLinkClicks') | thousandSeprator }}</strong>
                </td>
                <td v-if="storyColStatuses.sticker_taps">
                  <strong>{{ calStoryTotal('totalStickerTaps') === 0 ? '-' : calStoryTotal('totalStickerTaps') | thousandSeprator }}</strong>
                </td>
                <td v-if="storyColStatuses.interactions">
                  <strong>{{ calStoryTotal('totalInteractions') === 0 ? '-' : calStoryTotal('totalInteractions') | thousandSeprator }}</strong>
                </td>
                <td v-if="storyColStatuses.avg_views"><strong>{{ calStoryTotal('totalAvgViews') === 0 ? '-' : calStoryTotal('totalAvgViews') | thousandSeprator }}</strong></td>
                <td v-if="storyColStatuses.avg_reels_plays"><strong>{{ calStoryTotal('totalAvgReelPlays') === 0 ? '-' : calStoryTotal('totalAvgReelPlays') | thousandSeprator }}</strong></td>
              </tr>
            </template>
            <template v-slot:no-data>No Data</template>
          </v-data-table>
        </div>

        <div class="mb-5 pb-5">
          <div class="d-flex" style="justify-content:space-between">
            <div class="h4 mb-2">Reel Analysis Summary</div>
            <div style="margin-top:-5px" class="text-right">
              <v-menu
                :close-on-content-click="false"
                bottom
                left
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    color="secondary"
                    v-bind="attrs"
                    v-on="on"
                    @click="openColSettingsModal('reel')"
                  >
                    <i class="fas fa-cog fa-lg" data-toggle="tooltip" data-placement="top" title="Settings"></i>
                  </v-btn>
                </template>
              </v-menu>
            </div>
          </div>
          <v-row class="no-gutters">
            <v-col cols="12" sm="12" md="12" lg="12">
              <v-row class="action-section mb-0 mt-2 ml-1">
                <v-col class="action-group-section pl-0" cols="12" sm="3" md="3" lg="3">
                  <div class="d-flex flex-row" style="gap:3px">
                    <div>
                      <v-btn
                        class="mb-2"
                        color="warning"
                        small
                        v-if="selectedReelAnalysis && selectedReelAnalysis.length > 0"
                        @click="openReelAnalysisAvgModal()"
                      >Calculate Average ({{selectedReelAnalysis.length}})</v-btn>
                    </div>
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <!-- BEGIN vue data table -->
          <v-data-table 
          :headers="computedReelTableHeaders" 
          :search="filter" 
          :items="reelAnalysisData"
          show-select
          :single-select="false"
          v-model="selectedReelAnalysis" 
          class="statistics-analysis-table elevation-1">
            <template v-for="(h, index) in computedReelTableHeaders" v-slot:[`header.${h.value}`]="{ header }">
              <legend-icon :key="index" :header="h" rootClass="legend-row" />
            </template>
             <template v-slot:item.contents="{ item }">
              <td class="text-left" style="min-width:180px">
                <span v-if="item.campaign">{{item.campaign.name}}</span>
              </td>
            </template>
            <template v-slot:[`item.url`]="{ item }">
              <td class="text-left">
                <v-btn
                  x-small
                  text
                  color="secondary"
                  elevation="0"
                  :href="item.url"
                  :target="'_blank'"
                >
                  View
                </v-btn>
              </td>
            </template>
            <template v-slot:item.outreach="{ item }">
              {{item.outreach === 0 ? '-' : item.outreach | thousandSeprator}}
            </template>
            <template v-slot:item.likes="{ item }">
              {{item.likes === 0 ? '-' : item.likes | thousandSeprator}}
            </template>
            <template v-slot:item.comments="{ item }">
              {{item.comments === 0 ? '-' : item.comments | thousandSeprator}}
            </template>
            <template v-slot:item.saved="{ item }">
              {{item.saved === 0 ? '-' : item.saved | thousandSeprator}}
            </template>
            <template v-slot:item.interactions="{ item }">
              {{item.interactions === 0 ? '-' : item.interactions | thousandSeprator}}
            </template>
            <template v-slot:item.shares="{ item }">
              {{item.shares === 0 ? '-' : item.shares}}
            </template>
            <template v-slot:item.views="{ item }">
              {{item.views === 0 ? '-' : item.views}}
            </template>
            <template v-slot:item.reach="{ item }">
              {{item.reach === 0 ? '-' : item.reach}}
            </template>
            <template v-slot:item.impressions="{ item }">
              {{item.impressions === 0 ? '-' : item.impressions}}
            </template>
            <template v-slot:item.plays="{ item }">
              {{item.plays === 0 ? '-' : showReelPlayTime(item.plays)}}
            </template>
            <template v-slot:item.watches="{ item }">
              {{item.watches === 0 ? '-' : item.watches}}
            </template>
            <template v-slot:item.new_engagement_rate="{ item }">
              <div>
                {{item.new_engagement_rate === 0 ? '-' : item.new_engagement_rate + '%'}}
              </div>
            </template>
            <template v-slot:item.new_engagement_rate_view="{ item }">
              <div>
                {{item.new_engagement_rate_view === 0 || !item.new_engagement_rate_view ? '-' : item.new_engagement_rate_view + '%'}}
              </div>
            </template>
            <template v-slot:item.interaction_rate_plays="{ item }">
              <div>
                {{item.interaction_rate_plays === 0 || !item.interaction_rate_plays ? '-' : item.interaction_rate_plays + '%'}}
              </div>
            </template>            
            <template v-slot:item.engagement_rate_reach="{ item }">
              <div>
                {{item.engagement_rate_reach === 0 || item.engagement_rate_reach == 'Infinity' || !item.engagement_rate_reach ? '-' : item.engagement_rate_reach + '%'}}
              </div>
            </template>            
            <template v-slot:item.engagement_rate_sd="{ item }">
              <div v-if="item.engagement_rate_sd && item.engagement_rate_sd !== '0.00'">
                {{item.engagement_rate_sd === null ? '-' : item.engagement_rate_sd + '%'}}
              </div>
              <div v-else>
                <v-icon small data-toggle="tooltip" data-placement="top" title="Hidden">mdi-eye-off</v-icon>
              </div>
            </template>
            <template v-slot:item.median_engagement_rate="{ item }">
              {{item.median_engagement_rate === null || item.median_engagement_rate === 0 ? '-' : item.median_engagement_rate + '%'}}
            </template>
            <template v-slot:item.avg_likes="{ item }">
              {{item.avg_likes === null || !item.avg_likes ? '-' : item.avg_likes | thousandSeprator}}
            </template>
            <template v-slot:item.avg_comments="{ item }">
              {{item.avg_comments === null || !item.avg_comments ? '-' : item.avg_comments | thousandSeprator}}
            </template>
            <template v-slot:item.avg_views="{ item }">
              {{item.avg_views === null || !item.avg_views ? '-' : item.avg_views | thousandSeprator}}
            </template>
            <template v-slot:item.avg_reels_plays="{ item }">
              {{item.avg_reels_plays === null || !item.avg_reels_plays ? '-' : item.avg_reels_plays | thousandSeprator}}
            </template>
            <template slot="body.append">
              <tr style="font-weight:500;">
                <td><strong>AVERAGE</strong></td>
                <td v-if="reelColStatuses.contents"><strong>-</strong></td>
                <td v-if="reelColStatuses.live_date"><strong>-</strong></td>
                <td v-if="reelColStatuses.url"><strong>-</strong></td>
                <td><strong>{{ calReelTotal('totalOutreach') === 0 ? '-' : calReelTotal('totalOutreach') | thousandSeprator }}</strong></td>
                <td v-if="reelColStatuses.reach">
                  <strong>{{ calReelTotal('totalReach') === 0 ? '-' : calReelTotal('totalReach') | thousandSeprator }}</strong>
                </td>
                <td v-if="reelColStatuses.impressions">
                  <strong>{{ calReelTotal('totalImpressions') === 0 ? '-' : calReelTotal('totalImpressions') | thousandSeprator }}</strong>
                </td>
                <td v-if="reelColStatuses.likes">
                  <strong>{{ calReelTotal('totalLikes') === 0 ? '-' : calReelTotal('totalLikes') | thousandSeprator }}</strong>
                </td>
                <td v-if="reelColStatuses.shares">
                  <strong>{{ calReelTotal('totalShares') === 0 ? '-' : calReelTotal('totalShares') | thousandSeprator }}</strong>
                </td>
                <td v-if="reelColStatuses.comments">
                  <strong>{{ calReelTotal('totalComments') === 0 ? '-' : calReelTotal('totalComments') | thousandSeprator }}</strong>
                </td>
                <td v-if="reelColStatuses.saved">
                  <strong>{{ calReelTotal('totalSaved') === 0 ? '-' : calReelTotal('totalSaved') | thousandSeprator }}</strong>
                </td>
                <td v-if="reelColStatuses.interactions">
                  <strong>{{ calReelTotal('totalInteractions') === 0 ? '-' : calReelTotal('totalInteractions') | thousandSeprator }}</strong>
                </td>
                <td v-if="reelColStatuses.views">
                  <strong>{{ calReelTotal('totalViews') === 0 ? '-' : calReelTotal('totalViews') | thousandSeprator }}</strong>
                </td>
                <td v-if="reelColStatuses.plays"><strong>{{ totalPlayTime }}</strong></td>
                <td v-if="reelColStatuses.watches"><strong>{{ totalReelWatchTime }}</strong></td>
                <td v-if="reelColStatuses.new_engagement_rate">
                  <strong>{{ calReelTotal('totalEngagementRate') === 0 ? '-' : calReelTotal('totalEngagementRate') + '%'}}</strong>
                </td>
                <td v-if="reelColStatuses.new_engagement_rate_view">
                  <strong>{{ calReelTotal('totalEngagementRateView') === 0 ? '-' : calReelTotal('totalEngagementRateView') + '%'}}</strong>
                </td>
                <td v-if="reelColStatuses.interaction_rate_plays">
                  <strong>{{ calReelTotal('totalInteractionRatePlays') === 0 ? '-' : calReelTotal('totalInteractionRatePlays') + '%'}}</strong>
                </td>
                <td v-if="reelColStatuses.engagement_rate_reach">
                  <strong>{{ calReelTotal('totalEngagementRateReach') === 0 ? '-' : calReelTotal('totalEngagementRateReach') + '%'}}</strong>
                </td>
                <td v-if="reelColStatuses.engagement_rate_sd"><strong>{{ calReelTotal('totalEngRateSd') === 0 ? '-' : calReelTotal('totalEngRateSd')+ '%'}}</strong></td>
                <td v-if="reelColStatuses.median_engagement_rate"><strong>{{ calReelTotal('totalMedianEngRate') === 0 ? '-' : calReelTotal('totalMedianEngRate') + '%'}}</strong></td>
                <td v-if="reelColStatuses.avg_likes"><strong>{{ calReelTotal('totalAvgLikes') === 0 ? '-' : calReelTotal('totalAvgLikes')}}</strong></td>
                <td v-if="reelColStatuses.avg_comments"><strong>{{ calReelTotal('totalAvgComments') === 0 ? '-' : calReelTotal('totalAvgComments')}}</strong></td>
                <td v-if="reelColStatuses.avg_views"><strong>{{ calReelTotal('totalAvgViews') === 0 ? '-' : calReelTotal('totalAvgViews')}}</strong></td>
                <td v-if="reelColStatuses.avg_reels_plays"><strong>{{ calReelTotal('totalReelPlays') === 0 ? '-' : calReelTotal('totalReelPlays')}}</strong></td>
              </tr>
            </template>
            <template v-slot:no-data>No Data</template>
          </v-data-table>
        </div>

        <div class="mb-5 pb-5">
          <div class="d-flex" style="justify-content:space-between">
            <div class="h4 mb-2">TikTok Analysis Summary</div>
            <div style="margin-top:-5px" class="text-right">
              <v-menu
                :close-on-content-click="false"
                bottom
                left
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    color="secondary"
                    v-bind="attrs"
                    v-on="on"
                    @click="openColSettingsModal('tiktok')"
                  >
                    <i class="fas fa-cog fa-lg" data-toggle="tooltip" data-placement="top" title="Settings"></i>
                  </v-btn>
                </template>
              </v-menu>
            </div>
          </div>
          <v-row class="no-gutters">
            <v-col cols="12" sm="12" md="12" lg="12">
              <v-row class="action-section mb-0 mt-2 ml-1">
                <v-col class="action-group-section pl-0" cols="12" sm="3" md="3" lg="3">
                  <div class="d-flex flex-row" style="gap:3px">
                    <div>
                      <v-btn
                        class="mb-2"
                        color="warning"
                        small
                        v-if="selectedTikTokAnalysis && selectedTikTokAnalysis.length > 0"
                        @click="openTikTokAnalysisAvgModal()"
                      >Calculate Average ({{selectedTikTokAnalysis.length}})</v-btn>
                    </div>
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <!-- BEGIN vue data table -->
          <v-data-table 
          :headers="computedTikTokTableHeaders" 
          :search="filter" 
          :items="tiktokAnalysisData"
          show-select
          :single-select="false"
          v-model="selectedTikTokAnalysis" 
          class="statistics-analysis-table elevation-1">
            <template v-for="(h, index) in computedTikTokTableHeaders" v-slot:[`header.${h.value}`]="{ header }">
              <legend-icon :key="index" :header="h" rootClass="legend-row" />
            </template>
            <template v-slot:item.contents="{ item }">
              <td class="text-left" style="min-width:180px">
                <span v-if="item.campaign">{{item.campaign.name}}</span>
              </td>
            </template>
            <template v-slot:[`item.url`]="{ item }">
              <td class="text-left">
                <v-btn
                  x-small
                  text
                  color="secondary"
                  elevation="0"
                  :href="item.url"
                  :target="'_blank'"
                >
                  View
                </v-btn>
              </td>
            </template>
            <template v-slot:item.outreach="{ item }">
              {{item.outreach === 0 || !item.outreach ? '-' : item.outreach | thousandSeprator}}
            </template>
            <template v-slot:item.views="{ item }">
              {{item.views === 0 ? '-' : item.views | thousandSeprator}}
            </template>
            <template v-slot:item.likes="{ item }">
              {{item.likes === 0 ? '-' : item.likes | thousandSeprator}}
            </template>
            <template v-slot:item.comments="{ item }">
              {{item.comments === 0 ? '-' : item.comments | thousandSeprator}}
            </template>
            <template v-slot:item.saved="{ item }">
              {{item.saved === 0 ? '-' : item.saved | thousandSeprator}}
            </template>
            <template v-slot:item.shares="{ item }">
              {{item.shares === 0 ? '-' : item.shares | thousandSeprator}}
            </template>
            <template v-slot:item.reach="{ item }">
              {{item.reach === 0 ? '-' : item.reach}}
            </template>
            <template v-slot:item.impressions="{ item }">
              {{item.impressions === 0 ? '-' : item.impressions}}
            </template>
            <template v-slot:item.plays="{ item }">
              {{item.plays === 0 ? '-' : showTikTokPlayTime(item.plays)}}
            </template>
            <template v-slot:item.watches="{ item }">
              {{item.watches === 0 ? '-' : item.watches}}
            </template>
            <template v-slot:item.new_engagement_rate="{ item }">
              {{item.new_engagement_rate === null || !item.new_engagement_rate ? '-' : item.new_engagement_rate + '%'}}
            </template>
            <template v-slot:item.new_engagement_rate_view="{ item }">
              {{item.new_engagement_rate_view === null || !item.new_engagement_rate_view ? '-' : item.new_engagement_rate_view + '%'}}
            </template>
            <template v-slot:item.interaction_rate_plays="{ item }">
              {{item.interaction_rate_plays === null || !item.interaction_rate_plays ? '-' : item.interaction_rate_plays + '%'}}
            </template>
            <template v-slot:item.eng_rate_total_viewers="{ item }">
              {{item.eng_rate_total_viewers === null || !item.eng_rate_total_viewers ? '-' : item.eng_rate_total_viewers + '%'}}
            </template>
            <template v-slot:item.engagement_rate_sd="{ item }">
              {{item.engagement_rate_sd === null || !item.eng_rate_total_viewers ? '-' : item.engagement_rate_sd + '%'}}
            </template>
            <template v-slot:item.median_engagement_rate="{ item }">
              {{item.median_engagement_rate === null || !item.eng_rate_total_viewers ? '-' : item.median_engagement_rate + '%'}}
            </template>
            <template v-slot:item.watchedFullVideo="{ item }">
              {{item.watchedFullVideo === null ? '-' : item.watchedFullVideo + '%'}}
            </template>
            <template slot="body.append">
              <tr style="font-weight:500;">
                <td><strong>AVERAGE</strong></td>
                <td v-if="tiktokColStatuses.contents"><strong>-</strong></td>
                <td v-if="tiktokColStatuses.live_date"><strong>-</strong></td>
                <td v-if="tiktokColStatuses.url"><strong>-</strong></td>
                <td v-if="tiktokColStatuses.outreach"><strong>{{ calTikTokTotal('totalOutreach') === 0 ? '-' : calTikTokTotal('totalOutreach') | thousandSeprator }}</strong></td>
                <td v-if="tiktokColStatuses.plays"><strong>{{ totalTikTokPlayTime }}</strong></td>
                <td v-if="tiktokColStatuses.watches"><strong>{{ calTikTokTotal('totalWatches') === '0s' ? '-' : calTikTokTotal('totalWatches')}}</strong></td>
                <td v-if="tiktokColStatuses.likes"><strong>{{ calTikTokTotal('totalLikes') === 0 ? '-' : calTikTokTotal('totalLikes') | thousandSeprator }}</strong></td>
                <td v-if="tiktokColStatuses.comments"><strong>{{ calTikTokTotal('totalComments') === 0 ? '-' : calTikTokTotal('totalComments') | thousandSeprator }}</strong></td>
                <td v-if="tiktokColStatuses.shares"><strong>{{ calTikTokTotal('totalShares') === 0 ? '-' : calTikTokTotal('totalShares') | thousandSeprator }}</strong></td>
                <td v-if="tiktokColStatuses.saved"><strong>{{ calTikTokTotal('totalBookmarks') === 0 ? '-' : calTikTokTotal('totalBookmarks') | thousandSeprator }}</strong></td>
                <td v-if="tiktokColStatuses.interactions"><strong>{{ calTikTokTotal('totalInteractions') === 0 ? '-' : calTikTokTotal('totalInteractions') | thousandSeprator }}</strong></td>
                <td v-if="tiktokColStatuses.views"><strong>{{ calTikTokTotal('totalViews') === 0 ? '-' : calTikTokTotal('totalViews') | thousandSeprator }}</strong></td>
                <td v-if="tiktokColStatuses.reach"><strong>{{ calTikTokTotal('totalReach') === 0 ? '-' : calTikTokTotal('totalReach') | thousandSeprator }}</strong></td>
                <td v-if="tiktokColStatuses.impressions"><strong>{{ calTikTokTotal('totalImpressions') === 0 ? '-' : calTikTokTotal('totalImpressions') | thousandSeprator }}</strong></td>
                <td v-if="tiktokColStatuses.avg_views"><strong>{{ calTikTokTotal('totalAvgViews') === 0 ? '-' : calTikTokTotal('totalAvgViews')}}</strong></td>
                <td v-if="tiktokColStatuses.avg_likes"><strong>{{ calTikTokTotal('totalAvgLikes') === 0 ? '-' : calTikTokTotal('totalAvgLikes')}}</strong></td>
                <td v-if="tiktokColStatuses.avg_comments"><strong>{{ calTikTokTotal('totalAvgComments') === 0 ? '-' : calTikTokTotal('totalAvgComments')}}</strong></td>
                <td v-if="tiktokColStatuses.avg_saves"><strong>{{ calTikTokTotal('totalAvgSaves') === 0 ? '-' : calTikTokTotal('totalAvgSaves')}}</strong></td>
                <td v-if="tiktokColStatuses.avg_shares"><strong>{{ calTikTokTotal('totalAvgShares') === 0 ? '-' : calTikTokTotal('totalAvgShares')}}</strong></td>
                <td v-if="tiktokColStatuses.new_engagement_rate"><strong>{{ calTikTokTotal('totalEngagementRate') === 0 ? '-' : calTikTokTotal('totalEngagementRate') + '%'}}</strong></td>
                <td v-if="tiktokColStatuses.new_engagement_rate_view"><strong>{{ calTikTokTotal('totalEngagementRateView') === 0 || !calTikTokTotal('totalEngagementRateView') ? '-' : calTikTokTotal('totalEngagementRateView') + '%'}}</strong></td>
                <td v-if="tiktokColStatuses.interaction_rate_plays"><strong>{{ calTikTokTotal('totalInteractionRatePlays') === 0 || !calTikTokTotal('totalInteractionRatePlays') ? '-' : calTikTokTotal('totalInteractionRatePlays') + '%'}}</strong></td>
                <td v-if="tiktokColStatuses.eng_rate_total_viewers"><strong>{{ calTikTokTotal('totalEngRateTotalViewers') === 0 ? '-' : calTikTokTotal('totalEngRateTotalViewers') + '%'}}</strong></td>
                <td v-if="tiktokColStatuses.engagement_rate_sd"><strong>{{ calTikTokTotal('totalEngRateSd') === 0 || !calTikTokTotal('totalEngRateSd') ? '-' : calTikTokTotal('totalEngRateSd') + '%'}}</strong></td>
                <td v-if="tiktokColStatuses.median_engagement_rate"><strong>{{ calTikTokTotal('totalMedianEngRateSd') === 0 ? '-' : calTikTokTotal('totalMedianEngRateSd') + '%'}}</strong></td>
                <td v-if="tiktokColStatuses.watchedFullVideo"><strong>{{ calTikTokTotal('totalWatchedFullVideo') === 0 ? '-' : calTikTokTotal('totalWatchedFullVideo') + '%'}}</strong></td>
              </tr>
            </template>
            <template v-slot:no-data>No Data</template>
          </v-data-table>
        </div>
      
        <div class="mb-5 pb-5">
          <div class="d-flex" style="justify-content:space-between">
            <div class="h4 mb-2">Youtube Analysis Summary</div>
            <div style="margin-top:-5px" class="text-right">
              <v-menu
                :close-on-content-click="false"
                bottom
                left
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    color="secondary"
                    v-bind="attrs"
                    v-on="on"
                    @click="openColSettingsModal('youtube')"
                  >
                    <i class="fas fa-cog fa-lg" data-toggle="tooltip" data-placement="top" title="Settings"></i>
                  </v-btn>
                </template>
              </v-menu>
            </div>
          </div>
          <v-row class="no-gutters">
            <v-col cols="12" sm="12" md="12" lg="12">
              <v-row class="action-section mb-0 mt-2 ml-1">
                <v-col class="action-group-section pl-0" cols="12" sm="3" md="3" lg="3">
                  <div class="d-flex flex-row" style="gap:3px">
                    <div>
                      <v-btn
                        class="mb-2"
                        color="warning"
                        small
                        v-if="selectedYoutubeAnalysis && selectedYoutubeAnalysis.length > 0"
                        @click="openYoutubeAnalysisAvgModal()"
                      >Calculate Average ({{selectedYoutubeAnalysis.length}})</v-btn>
                    </div>
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <!-- BEGIN vue data table -->
          <v-data-table
          :headers="computedYoutubeTableHeaders" 
          :search="filter" 
          :items="youtubeAnalysisData" 
          show-select
          :single-select="false"
          v-model="selectedYoutubeAnalysis" 
          class="statistics-analysis-table elevation-1">
            <template v-for="(h, index) in computedYoutubeTableHeaders" v-slot:[`header.${h.value}`]="{ header }">
              <legend-icon :key="index" :header="h" rootClass="legend-row" />
            </template>
            <template v-slot:item.contents="{ item }">
              <td class="text-left" style="min-width:180px">
                <span v-if="item.campaign">{{item.campaign.name}}</span>
              </td>
            </template>
            <template v-slot:[`item.url`]="{ item }">
              <td class="text-left">
                <v-btn
                  x-small
                  text
                  color="secondary"
                  elevation="0"
                  :href="item.url"
                  :target="'_blank'"
                >
                  View
                </v-btn>
              </td>
            </template>
            <template v-slot:item.outreach="{ item }">
              {{item.outreach === 0 || !item.outreach ? '-' : item.outreach | thousandSeprator}}
            </template>
            <template v-slot:item.views="{ item }">
              {{item.views === 0 ? '-' : item.views | thousandSeprator}}
            </template>
            <template v-slot:item.likes="{ item }">
              {{item.likes === 0 ? '-' : item.likes | thousandSeprator}}
            </template>
            <template v-slot:item.comments="{ item }">
              {{item.comments === 0 ? '-' : item.comments | thousandSeprator}}
            </template>
            <template v-slot:item.new_engagement_rate="{ item }">
              {{item.new_engagement_rate === null || !item.new_engagement_rate_view  ? '-' : item.new_engagement_rate + '%'}}
            </template>
            <template v-slot:item.new_engagement_rate_view="{ item }">
              {{item.new_engagement_rate_view === null || !item.new_engagement_rate_view  ? '-' : item.new_engagement_rate_view + '%'}}
            </template>
            <template v-slot:item.engagement_rate_sd="{ item }">
              {{item.engagement_rate_sd === null || !item.new_engagement_rate_view  ? '-' : item.engagement_rate_sd + '%'}}
            </template>
            <template v-slot:item.median_engagement_rate="{ item }">
              {{item.median_engagement_rate === null || !item.new_engagement_rate_view  ? '-' : item.median_engagement_rate + '%'}}
            </template>
            <template slot="body.append">
              <tr style="font-weight:500;">
                <td><strong>AVERAGE</strong></td>
                <td v-if="youtubeColStatuses.contents"><strong>-</strong></td>
                <td v-if="youtubeColStatuses.live_date"><strong>-</strong></td>
                <td v-if="youtubeColStatuses.url"><strong>-</strong></td>
                <td v-if="youtubeColStatuses.outreach"><strong>{{ calYoutubeTotal('totalOutreach') === 0 ? '-' : calYoutubeTotal('totalOutreach') | thousandSeprator }}</strong></td>
                <td v-if="youtubeColStatuses.views"><strong>{{ calYoutubeTotal('totalViews') === 0 ? '-' : calYoutubeTotal('totalViews') | thousandSeprator }}</strong></td>
                <td v-if="youtubeColStatuses.likes"><strong>{{ calYoutubeTotal('totalLikes') === 0 ? '-' : calYoutubeTotal('totalLikes') | thousandSeprator }}</strong></td>
                <td v-if="youtubeColStatuses.comments"><strong>{{ calYoutubeTotal('totalComments') === 0 ? '-' : calYoutubeTotal('totalComments') | thousandSeprator }}</strong></td>
                <td v-if="youtubeColStatuses.interactions"><strong>{{ calYoutubeTotal('totalInteractions') === 0 ? '-' : calYoutubeTotal('totalInteractions') | thousandSeprator }}</strong></td>
                <td v-if="youtubeColStatuses.avg_views"><strong>{{ calYoutubeTotal('totalAvgViews') === 0 ? '-' : calYoutubeTotal('totalAvgViews') | thousandSeprator }}</strong></td>
                <td v-if="youtubeColStatuses.avg_likes"><strong>{{ calYoutubeTotal('totalAvgLikes') === 0 ? '-' : calYoutubeTotal('totalAvgLikes') | thousandSeprator }}</strong></td>
                <td v-if="youtubeColStatuses.avg_comments"><strong>{{ calYoutubeTotal('totalAvgComments') === 0 ? '-' : calYoutubeTotal('totalAvgComments') | thousandSeprator }}</strong></td>
                <td v-if="youtubeColStatuses.new_engagement_rate"><strong>{{ calYoutubeTotal('totalEngagementRate') === 0 ? '-' : calYoutubeTotal('totalEngagementRate') + '%' }}</strong></td>
                <td v-if="youtubeColStatuses.new_engagement_rate_view"><strong>{{ calYoutubeTotal('totalEngagementRateView') === 0 ? '-' : calYoutubeTotal('totalEngagementRateView') + '%' }}</strong></td>
                <td v-if="youtubeColStatuses.engagement_rate_sd"><strong>{{ calYoutubeTotal('totalEngagementRateSd') === 0 ? '-' : calYoutubeTotal('totalEngagementRateSd') + '%' }}</strong></td>
                <td v-if="youtubeColStatuses.median_engagement_rate"><strong>{{ calYoutubeTotal('totalMedianEngagementRate') === 0 ? '-' : calYoutubeTotal('totalMedianEngagementRate') + '%' }}</strong></td>
              </tr>
            </template>
            <template v-slot:no-data>No Data</template>
          </v-data-table>
        </div>

        <div class="mb-5 pb-5">
          <div class="d-flex" style="justify-content:space-between">
            <div class="h4 mb-2">XHS Analysis Summary</div>
            <div style="margin-top:-5px" class="text-right">
              <v-menu
                :close-on-content-click="false"
                bottom
                left
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    color="secondary"
                    v-bind="attrs"
                    v-on="on"
                    @click="openColSettingsModal('xhs')"
                  >
                    <i class="fas fa-cog fa-lg" data-toggle="tooltip" data-placement="top" title="Settings"></i>
                  </v-btn>
                </template>
              </v-menu>
            </div>
          </div>
          <v-row class="no-gutters">
            <v-col cols="12" sm="12" md="12" lg="12">
              <v-row class="action-section mb-0 mt-2 ml-1">
                <v-col class="action-group-section pl-0" cols="12" sm="3" md="3" lg="3">
                  <div class="d-flex flex-row" style="gap:3px">
                    <div>
                      <v-btn
                        class="mb-2"
                        color="warning"
                        small
                        v-if="selectedXhsAnalysis && selectedXhsAnalysis.length > 0"
                        @click="openXhsAnalysisAvgModal()"
                      >Calculate Average ({{selectedXhsAnalysis.length}})</v-btn>
                    </div>
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <!-- BEGIN vue data table -->
          <v-data-table 
          :headers="computedXHSTableHeaders" 
          :search="filter" 
          :items="xhsAnalysisData" 
          show-select
          :single-select="false"
          v-model="selectedXhsAnalysis" 
          class="statistics-analysis-table elevation-1">
            <template v-for="(h, index) in computedXHSTableHeaders" v-slot:[`header.${h.value}`]="{ header }">
              <legend-icon :key="index" :header="h" rootClass="legend-row" />
            </template>
            <template v-slot:item.contents="{ item }">
              <td class="text-left" style="min-width:180px">
                <span v-if="item.campaign">{{item.campaign.name}}</span>
              </td>
            </template>
            <template v-slot:item.outreach="{ item }">
              {{item.outreach === 0 || !item.outreach ? '-' : item.outreach | thousandSeprator}}
            </template>
            <template v-slot:item.like_count="{ item }">
              {{item.like_count === 0 ? '-' : item.like_count | thousandSeprator}}
            </template>
            <template v-slot:item.comment_count="{ item }">
              {{item.comment_count === 0 ? '-' : item.comment_count | thousandSeprator}}
            </template>
            <template v-slot:item.views="{ item }">
              {{item.views === 0 ? '-' : item.views | thousandSeprator}}
            </template>
            <template v-slot:item.shares="{ item }">
              {{item.shares === 0 ? '-' : item.shares | thousandSeprator}}
            </template>
            <template v-slot:item.bookmarks="{ item }">
              {{item.bookmarks === 0 ? '-' : item.bookmarks | thousandSeprator}}
            </template>
            <template slot="body.append">
              <tr style="font-weight:500;">
                <td><strong>AVERAGE</strong></td>
                <td v-if="xhsColStatuses.contents"><strong>-</strong></td>
                <td v-if="xhsColStatuses.live_date"><strong>-</strong></td>
                <td v-if="xhsColStatuses.outreach"><strong>{{ calXHSTotal('totalOutreach') === 0 ? '-' : calXHSTotal('totalOutreach') | thousandSeprator }}</strong></td>
                <td v-if="xhsColStatuses.like_count"><strong>{{ calXHSTotal('totalLikes') === 0 ? '-' : calXHSTotal('totalLikes') | thousandSeprator }}</strong></td>
                <td v-if="xhsColStatuses.comment_count"><strong>{{ calXHSTotal('totalComments') === 0 ? '-' : calXHSTotal('totalComments') | thousandSeprator }}</strong></td>
                <td v-if="xhsColStatuses.views"><strong>{{ calXHSTotal('totalViews') === 0 ? '-' : calXHSTotal('totalViews') | thousandSeprator }}</strong></td>
                <td v-if="xhsColStatuses.shares"><strong>{{ calXHSTotal('totalShares') === 0 ? '-' : calXHSTotal('totalShares') | thousandSeprator }}</strong></td>
                <td v-if="xhsColStatuses.bookmarks"><strong>{{ calXHSTotal('totalBookmarks') === 0 ? '-' : calXHSTotal('totalBookmarks') | thousandSeprator }}</strong></td>
                <td v-if="xhsColStatuses.interactions"><strong>{{ calXHSTotal('totalInteractions') === 0 ? '-' : calXHSTotal('totalInteractions') | thousandSeprator }}</strong></td>
              </tr>
            </template>
            <template v-slot:no-data>No Data</template>
          </v-data-table>
        </div>

        <div class="mb-5 pb-5">
          <div class="d-flex" style="justify-content:space-between">
            <div class="h4 mb-2">Facebook Analysis Summary</div>
            <div style="margin-top:-5px" class="text-right">
              <v-menu
                :close-on-content-click="false"
                bottom
                left
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    color="secondary"
                    v-bind="attrs"
                    v-on="on"
                    @click="openColSettingsModal('facebook')"
                  >
                    <i class="fas fa-cog fa-lg" data-toggle="tooltip" data-placement="top" title="Settings"></i>
                  </v-btn>
                </template>
              </v-menu>
            </div>
          </div>
          <v-row class="no-gutters">
            <v-col cols="12" sm="12" md="12" lg="12">
              <v-row class="action-section mb-0 mt-2 ml-1">
                <v-col class="action-group-section pl-0" cols="12" sm="3" md="3" lg="3">
                  <div class="d-flex flex-row" style="gap:3px">
                    <div>
                      <v-btn
                        class="mb-2"
                        color="warning"
                        small
                        v-if="selectedFbAnalysis && selectedFbAnalysis.length > 0"
                        @click="openFbAnalysisAvgModal()"
                      >Calculate Average ({{selectedFbAnalysis.length}})</v-btn>
                    </div>
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <!-- BEGIN vue data table -->
          <v-data-table 
          :headers="computedFbTableHeaders" 
          :search="filter"
          :items="fbAnalysisData" 
          show-select
          :single-select="false"
          v-model="selectedFbAnalysis" 
          class="statistics-analysis-table elevation-1">
            <template v-for="(h, index) in computedFbTableHeaders" v-slot:[`header.${h.value}`]="{ header }">
              <legend-icon :key="index" :header="h" rootClass="legend-row" />
            </template>
            <template v-slot:item.contents="{ item }">
              <td class="text-left" style="min-width:180px">
                <span v-if="item.campaign">{{item.campaign.name}}</span>
              </td>
            </template>
            <template v-slot:item.outreach="{ item }">
              {{item.outreach === 0 || !item.outreach ? '-' : item.outreach | thousandSeprator}}
            </template>
            <template v-slot:item.like_count="{ item }">
              {{item.like_count === 0 ? '-' : item.like_count | thousandSeprator}}
            </template>
            <template v-slot:item.comment_count="{ item }">
              {{item.comment_count === 0 ? '-' : item.comment_count | thousandSeprator}}
            </template>
            <template v-slot:item.views="{ item }">
              {{item.views === 0 ? '-' : item.views | thousandSeprator}}
            </template>
            <template v-slot:item.shares="{ item }">
              {{item.shares === 0 ? '-' : item.shares | thousandSeprator}}
            </template>
            <template v-slot:item.bookmarks="{ item }">
              {{item.bookmarks === 0 ? '-' : item.bookmarks | thousandSeprator}}
            </template>
            <template slot="body.append">
              <tr style="font-weight:500;">
                <td><strong>AVERAGE</strong></td>
                <td v-if="fbColStatuses.contents"><strong>-</strong></td>
                <td v-if="fbColStatuses.live_date"><strong>-</strong></td>
                <td v-if="fbColStatuses.outreach"><strong>{{ calFbTotal('totalOutreach') === 0 ? '-' : calFbTotal('totalOutreach') | thousandSeprator }}</strong></td>
                <td v-if="fbColStatuses.like_count"><strong>{{ calFbTotal('totalLikes') === 0 ? '-' : calFbTotal('totalLikes') | thousandSeprator }}</strong></td>
                <td v-if="fbColStatuses.comment_count"><strong>{{ calFbTotal('totalComments') === 0 ? '-' : calFbTotal('totalComments') | thousandSeprator }}</strong></td>
                <td v-if="fbColStatuses.views"><strong>{{ calFbTotal('totalViews') === 0 ? '-' : calFbTotal('totalViews') | thousandSeprator }}</strong></td>
                <td v-if="fbColStatuses.shares"><strong>{{ calFbTotal('totalShares') === 0 ? '-' : calFbTotal('totalShares') | thousandSeprator }}</strong></td>
                <td v-if="fbColStatuses.bookmarks"><strong>{{ calFbTotal('totalBookmarks') === 0 ? '-' : calFbTotal('totalBookmarks') | thousandSeprator }}</strong></td>
                <td v-if="fbColStatuses.interactions"><strong>{{ calFbTotal('totalInteractions') === 0 ? '-' : calFbTotal('totalInteractions') | thousandSeprator }}</strong></td>
              </tr>
            </template>
            <template v-slot:no-data>No Data</template>
          </v-data-table>
        </div>
      </v-col>
    </v-row>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true"
      loader="bars"
      background-color="#000"
      color="secondary"
      width.number="90"
      height.number="90"
    ></loading>
    <table-cols-show-hide-modal
      v-model="colSettingsDialog"
      :title="getUpdateColTitle()"
      :items="tableColsItems"
      @updated="updateTableCols"
    />
    <!-- post cal avg dialog -->
    <v-dialog v-model="avgPostAnalysisDialog" width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>Average Post Analysis</v-card-title>
        <v-card-text class="mt-3 body-2">
          <v-hover v-slot:default="{ hover }">
            <v-card
              color="#363636"
              dark
              :elevation="hover ? 12 : 2"
              :class="{ 'mx-auto mb-5 text-center on-hover': hover, 'mx-auto mb-5 text-center': !hover}"
              style="width:300px"
            >
              <v-card-subtitle>
                <p
                  class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                >
                <span>Total Entries:</span><span>{{selectedPostAnalysis.length}}</span>
                </p>
                <p
                  class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                >
                  <span>Outreach:</span>
                  <span>{{calPostAvg('totalOutreach') === 0 ? '-' : calPostAvg('totalOutreach')  | thousandSeprator}}</span>
                </p>
                <p
                  class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                >
                  <span>Accounts Reached:</span>
                  <span>{{calPostAvg('totalReach') === 0 ? '-' : calPostAvg('totalReach')  | thousandSeprator}}</span>
                </p>
                <p
                  class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                >
                  <span>Impressions:</span>
                  <span>{{calPostAvg('totalImpressions') === 0 ? '-' : calPostAvg('totalImpressions')  | thousandSeprator}}</span>
                </p>
                <p
                  class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                >
                  <span>Likes:</span>
                  <span>{{calPostAvg('totalLikes') === 0 ? '-' : calPostAvg('totalLikes')  | thousandSeprator}}</span>
                </p>
                <p
                  class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                >
                  <span>Shares:</span>
                  <span>{{calPostAvg('totalShares') === 0 ? '-' : calPostAvg('totalShares')  | thousandSeprator}}</span>
                </p>
                <p
                  class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                >
                  <span>Comments:</span>
                  <span>{{calPostAvg('totalComments') === 0 ? '-' : calPostAvg('totalComments')  | thousandSeprator}}</span>
                </p>
                <p
                  class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                >
                  <span>Saves:</span>
                  <span>{{calPostAvg('totalSaved') === 0 ? '-' : calPostAvg('totalSaved')  | thousandSeprator}}</span>
                </p>
                <p
                  class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                >
                  <span>Interactions:</span>
                  <span>{{calPostAvg('totalInteractions') === 0 ? '-' : calPostAvg('totalInteractions')  | thousandSeprator}}</span>
                </p>
                <p
                  class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                >
                  <span>Views:</span>
                  <span>{{calPostAvg('totalViews') === 0 ? '-' : calPostAvg('totalViews')  | thousandSeprator}}</span>
                </p>
                <p
                  class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                >
                  <span>Engagement Rate by Outreach:</span>
                  <span>{{calPostAvg('totalEngagementRate') === 0 ? '-' : calPostAvg('totalEngagementRate') + '%'}}</span>
                </p>
                <p
                  class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                >
                  <span>Play Rate (by Outreach)</span>
                  <span>{{calPostAvg('totalEngagementRateView') === 0 ? '-' : calPostAvg('totalEngagementRateView') + '%'}}</span>
                </p>
                <p
                  class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                >
                  <span>Engagement Rate by Reach</span>
                  <span>{{calPostAvg('totalEngagementRateReach') === 0 || calPostAvg('totalEngagementRateReach') == 'Infinity' ? '-' : calPostAvg('totalEngagementRateReach') + '%'}}</span>
                </p>
                <p
                  class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                >
                  <span>Avg. Engagement Rate</span>
                  <span>{{calPostAvg('totalEngRateSd') === 0 ? '-' : calPostAvg('totalEngRateSd') + '%'}}</span>
                </p>
                <p
                  class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                >
                  <span>Median Engagement Rate</span>
                  <span>{{calPostAvg('totalMedianEngRate') === 0 ? '-' : calPostAvg('totalMedianEngRate')}}</span>
                </p>
                <p
                  class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                >
                  <span>Average Likes</span>
                  <span>{{calPostAvg('totalAvgLikes') === 0 ? '-' : calPostAvg('totalAvgLikes')}}</span>
                </p>
                <p
                  class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                >
                  <span>Average Comments</span>
                  <span>{{calPostAvg('totalAvgComments') === 0 ? '-' : calPostAvg('totalAvgComments')}}</span>
                </p>
                <p
                  class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                >
                  <span>Average Views</span>
                  <span>{{calPostAvg('totalAvgViews') === 0 ? '-' : calPostAvg('totalAvgViews')}}</span>
                </p>
              </v-card-subtitle>
            </v-card>
          </v-hover>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" id="close" text @click.native="avgPostAnalysisDialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- story cal avg dialog -->
    <v-dialog v-model="avgStoryAnalysisDialog" width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>Average Story Analysis</v-card-title>
        <v-card-text class="mt-3 body-2">
          <v-hover v-slot:default="{ hover }">
            <v-card
              color="#363636"
              dark
              :elevation="hover ? 12 : 2"
              :class="{ 'mx-auto mb-5 text-center on-hover': hover, 'mx-auto mb-5 text-center': !hover}"
              style="width:300px"
            >
              <v-card-subtitle>
                <p
                  class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                >
                <span>Total Entries:</span><span>{{selectedStoryAnalysis.length}}</span>
                </p>
                <p
                  class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                >
                  <span>Outreach:</span>
                  <span>{{calStoryAvg('totalOutreach') === 0 ? '-' : calStoryAvg('totalOutreach')  | thousandSeprator}}</span>
                </p>
                <p
                  class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                >
                  <span>Accounts Reached:</span>
                  <span>{{calStoryAvg('totalReach') === 0 ? '-' : calStoryAvg('totalReach')  | thousandSeprator}}</span>
                </p>
                <p
                  class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                >
                  <span>Impressions:</span>
                  <span>{{calStoryAvg('totalImpressions') === 0 ? '-' : calStoryAvg('totalImpressions')  | thousandSeprator}}</span>
                </p>
                <p
                  class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                >
                  <span>Replies:</span>
                  <span>{{calStoryAvg('totalReplies') === 0 ? '-' : calStoryAvg('totalReplies')  | thousandSeprator}}</span>
                </p>
                <p
                  class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                >
                  <span>Shares:</span>
                  <span>{{calStoryAvg('totalShares') === 0 ? '-' : calStoryAvg('totalShares')  | thousandSeprator}}</span>
                </p>
                <p
                  class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                >
                  <span>Shares:</span>
                  <span>{{calStoryAvg('totalShares') === 0 ? '-' : calStoryAvg('totalShares')  | thousandSeprator}}</span>
                </p>
                <p
                  class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                >
                  <span>Links Click:</span>
                  <span>{{calStoryAvg('totalLinkClicks') === 0 ? '-' : calStoryAvg('totalLinkClicks')  | thousandSeprator}}</span>
                </p>
                <p
                  class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                >
                  <span>Sticker Taps:</span>
                  <span>{{calStoryAvg('totalStickerTaps') === 0 ? '-' : calStoryAvg('totalStickerTaps')  | thousandSeprator}}</span>
                </p>
                <p
                  class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                >
                  <span>Interactions:</span>
                  <span>{{calStoryAvg('totalInteractions') === 0 ? '-' : calStoryAvg('totalInteractions')  | thousandSeprator}}</span>
                </p>
                <p
                  class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                >
                  <span>Average Views:</span>
                  <span>{{ calStoryAvg('totalAvgViews') === 0 ? '-' : calStoryAvg('totalAvgViews') | thousandSeprator }}</span>
                </p>
                <p
                  class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                >
                  <span>Average Reels Plays:</span>
                  <span>{{ calStoryAvg('totalAvgReelPlays') === 0 ? '-' : calStoryAvg('totalAvgReelPlays') | thousandSeprator }}</span>
                </p>
              </v-card-subtitle>
            </v-card>
          </v-hover>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" id="close" text @click.native="avgStoryAnalysisDialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- reel cal avg dialog -->
    <v-dialog v-model="avgReelAnalysisDialog" width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>Average Reel Analysis</v-card-title>
        <v-card-text class="mt-3 body-2">
          <v-hover v-slot:default="{ hover }">
            <v-card
              color="#363636"
              dark
              :elevation="hover ? 12 : 2"
              :class="{ 'mx-auto mb-5 text-center on-hover': hover, 'mx-auto mb-5 text-center': !hover}"
              style="width:300px"
            >
              <v-card-subtitle>
                <p
                  class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                >
                <span>Total Entries:</span><span>{{selectedReelAnalysis.length}}</span>
                </p>
                <p
                  class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                >
                  <span>Outreach:</span>
                  <span>{{calReelAvg('totalOutreach') === 0 ? '-' : calReelAvg('totalOutreach')  | thousandSeprator}}</span>
                </p>
                <p
                  class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                >
                  <span>Accounts Reached:</span>
                  <span>{{calReelAvg('totalReach') === 0 ? '-' : calReelAvg('totalReach')  | thousandSeprator}}</span>
                </p>
                <p
                  class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                >
                  <span>Impressions:</span>
                  <span>{{calReelAvg('totalImpressions') === 0 ? '-' : calReelAvg('totalImpressions')  | thousandSeprator}}</span>
                </p>
                <p
                  class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                >
                  <span>Likes:</span>
                  <span>{{calReelAvg('totalLikes') === 0 ? '-' : calReelAvg('totalReplies')  | thousandSeprator}}</span>
                </p>
                <p
                  class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                >
                  <span>Shares:</span>
                  <span>{{calReelAvg('totalShares') === 0 ? '-' : calReelAvg('totalShares')  | thousandSeprator}}</span>
                </p>
                <p
                  class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                >
                  <span>Comments:</span>
                  <span>{{calReelAvg('totalComments') === 0 ? '-' : calReelAvg('totalComments')  | thousandSeprator}}</span>
                </p>
                <p
                  class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                >
                  <span>Saves:</span>
                  <span>{{calReelAvg('totalSaved') === 0 ? '-' : calReelAvg('totalSaved')  | thousandSeprator}}</span>
                </p>
                <p
                  class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                >
                  <span>Interactions:</span>
                  <span>{{ calReelAvg('totalInteractions') === 0 ? '-' : calReelAvg('totalInteractions') | thousandSeprator }}</span>
                </p>
                <p
                  class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                >
                  <span>Plays:</span>
                  <span>{{ calReelAvg('totalViews') === 0 ? '-' : calReelAvg('totalViews') | thousandSeprator }}</span>
                </p>
                <p
                  class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                >
                  <span>Watch Time:</span>
                  <span>{{ totalAvgPlayTime }}</span>
                </p>
                <p
                  class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                >
                  <span>Average Watch Time:</span>
                  <span>{{ totalAvgReelWatchTime }}</span>
                </p>
                <p
                  class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                >
                  <span>Engagement Rate by Outreach:</span>
                  <span>{{ calReelAvg('totalEngagementRate') === 0 ? '-' : calReelAvg('totalEngagementRate') + '%'}}</span>
                </p>
                <p
                  class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                >
                  <span>Play Rate (by Outreach):</span>
                  <span>{{ calReelAvg('totalEngagementRateView') === 0 ? '-' : calReelAvg('totalEngagementRateView') + '%'}}</span>
                </p>
                <p
                  class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                >
                  <span>Engagement Rate by Plays:</span>
                  <span>{{ calReelAvg('totalInteractionRatePlays') === 0 ? '-' : calReelAvg('totalInteractionRatePlays') + '%'}}</span>
                </p>
                <p
                  class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                >
                  <span>Engagement Rate by Reach:</span>
                  <span>{{ calReelAvg('totalEngagementRateReach') === 0 ? '-' : calReelAvg('totalEngagementRateReach') + '%'}}</span>
                </p>
                <p
                  class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                >
                  <span>Avg. Engagement Rate:</span>
                  <span>{{ calReelAvg('totalEngRateSd') === 0 ? '-' : calReelAvg('totalEngRateSd') + '%'}}</span>
                </p>
                <p
                  class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                >
                  <span>Median Engagement Rate:</span>
                  <span>{{ calReelAvg('totalMedianEngRate') === 0 ? '-' : calReelAvg('totalMedianEngRate') + '%'}}</span>
                </p>
                <p
                  class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                >
                  <span>Average Likes:</span>
                  <span>{{ calReelAvg('totalAvgLikes') === 0 ? '-' : calReelAvg('totalAvgLikes')}}</span>
                </p>
                <p
                  class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                >
                  <span>Average Comments:</span>
                  <span>{{ calReelAvg('totalAvgComments') === 0 ? '-' : calReelAvg('totalAvgComments')}}</span>
                </p>
                <p
                  class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                >
                  <span>Average Views:</span>
                  <span>{{ calReelAvg('totalAvgViews') === 0 ? '-' : calReelAvg('totalAvgViews')}}</span>
                </p>
                <p
                  class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                >
                  <span>Average Reels Plays:</span>
                  <span>{{ calReelAvg('totalReelPlays') === 0 ? '-' : calReelAvg('totalReelPlays')}}</span>
                </p>
              </v-card-subtitle>
            </v-card>
          </v-hover>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" id="close" text @click.native="avgReelAnalysisDialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- tiktok cal avg dialog -->
    <v-dialog v-model="avgTiktokAnalysisDialog" width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>Average TikTok Analysis</v-card-title>
        <v-card-text class="mt-3 body-2">
          <v-hover v-slot:default="{ hover }">
            <v-card
              color="#363636"
              dark
              :elevation="hover ? 12 : 2"
              :class="{ 'mx-auto mb-5 text-center on-hover': hover, 'mx-auto mb-5 text-center': !hover}"
              style="width:300px"
            >
              <v-card-subtitle>
                <p
                  class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                >
                <span>Total Entries:</span><span>{{selectedTikTokAnalysis.length}}</span>
                </p>
                <p
                  class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                >
                  <span>Outreach:</span>
                  <span>{{calTikTokAvg('totalOutreach') === 0 ? '-' : calReelAvg('totalOutreach')  | thousandSeprator}}</span>
                </p>
                <p
                  class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                >
                  <span>Total Play Time:</span>
                  <span>{{avgTikTokPlayTime}}</span>
                </p>
                <p
                  class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                >
                  <span>Average Watch Time:</span>
                  <span>{{calTikTokAvg('totalWatches') === '0s' ? '-' : calTikTokAvg('totalWatches')}}</span>
                </p>
                <p
                  class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                >
                  <span>Likes:</span>
                  <span>{{ calTikTokAvg('totalLikes') === 0 ? '-' : calTikTokAvg('totalLikes') | thousandSeprator }}</span>
                </p>
                <p
                  class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                >
                  <span>Comments:</span>
                  <span>{{ calTikTokAvg('totalComments') === 0 ? '-' : calTikTokAvg('totalComments') | thousandSeprator }}</span>
                </p>
                <p
                  class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                >
                  <span>Shares:</span>
                  <span>{{ calTikTokAvg('totalShares') === 0 ? '-' : calTikTokAvg('totalShares') | thousandSeprator }}</span>
                </p>
                <p
                  class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                >
                  <span>Favourites:</span>
                  <span>{{ calTikTokAvg('totalBookmarks') === 0 ? '-' : calTikTokAvg('totalBookmarks') | thousandSeprator }}</span>
                </p>
                <p
                  class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                >
                  <span>Interactions:</span>
                  <span>{{ calTikTokAvg('totalInteractions') === 0 ? '-' : calTikTokAvg('totalInteractions') | thousandSeprator }}</span>
                </p>
                <p
                  class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                >
                  <span>Plays:</span>
                  <span>{{ calTikTokAvg('totalViews') === 0 ? '-' : calTikTokAvg('totalViews') | thousandSeprator }}</span>
                </p>
                <p
                  class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                >
                  <span>Total Viewers:</span>
                  <span>{{ calTikTokAvg('totalReach') === 0 ? '-' : calTikTokAvg('totalReach') | thousandSeprator }}</span>
                </p>
                <p
                  class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                >
                  <span>Impressions:</span>
                  <span>{{ calTikTokAvg('totalImpressions') === 0 ? '-' : calTikTokAvg('totalImpressions') | thousandSeprator }}</span>
                </p>
                <p
                  class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                >
                  <span>Average Views:</span>
                  <span>{{ calTikTokAvg('totalAvgViews') === 0 ? '-' : calTikTokAvg('totalAvgViews') | thousandSeprator }}</span>
                </p>
                <p
                  class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                >
                  <span>Average Likes:</span>
                  <span>{{ calTikTokAvg('totalAvgLikes') === 0 ? '-' : calTikTokAvg('totalAvgLikes') | thousandSeprator }}</span>
                </p>
                <p
                  class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                >
                  <span>Average Comments:</span>
                  <span>{{ calTikTokAvg('totalAvgComments') === 0 ? '-' : calTikTokAvg('totalAvgComments') | thousandSeprator }}</span>
                </p>
                <p
                  class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                >
                  <span>Average Saves:</span>
                  <span>{{ calTikTokAvg('totalAvgSaves') === 0 ? '-' : calTikTokAvg('totalAvgSaves') | thousandSeprator }}</span>
                </p>
                <p
                  class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                >
                  <span>Average Shares:</span>
                  <span>{{ calTikTokAvg('totalAvgShares') === 0 ? '-' : calTikTokAvg('totalAvgShares') | thousandSeprator }}</span>
                </p>
                <p
                  class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                >
                  <span>Engagement Rate by Outreach:</span>
                  <span>{{ calTikTokAvg('totalEngagementRate') === 0 ? '-' : calTikTokAvg('totalEngagementRate') + '%'}}</span>
                </p>
                <p
                  class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                >
                  <span>Play Rate (by Outreach):</span>
                  <span>{{ calTikTokAvg('totalEngagementRateView') === 0 ? '-' : calTikTokAvg('totalEngagementRateView') + '%'}}</span>
                </p>
                <p
                  class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                >
                  <span>Engagement Rate by Plays:</span>
                  <span>{{ calTikTokAvg('totalInteractionRatePlays') === 0 ? '-' : calTikTokAvg('totalInteractionRatePlays') + '%'}}</span>
                </p>
                <p
                  class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                >
                  <span>Engagement Rate by Total Viewers:</span>
                  <span>{{ calTikTokAvg('totalEngRateTotalViewers') === 0 ? '-' : calTikTokAvg('totalEngRateTotalViewers') + '%'}}</span>
                </p>
                <p
                  class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                >
                  <span>Average Engagement Rate:</span>
                  <span>{{ calTikTokAvg('totalEngRateSd') === 0 ? '-' : calTikTokAvg('totalEngRateSd') + '%'}}</span>
                </p>
                <p
                  class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                >
                  <span>Median Engagement Rate:</span>
                  <span>{{ calTikTokAvg('totalMedianEngRateSd') === 0 ? '-' : calTikTokAvg('totalMedianEngRateSd') + '%'}}</span>
                </p>
                <p
                  class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                >
                  <span>Watched Full Video:</span>
                  <span>{{ calTikTokAvg('totalWatchedFullVideo') === 0 ? '-' : calTikTokAvg('totalWatchedFullVideo') + '%'}}</span>
                </p>
              </v-card-subtitle>
            </v-card>
          </v-hover>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" id="close" text @click.native="avgTiktokAnalysisDialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- youtube cal avg dialog -->
    <v-dialog v-model="avgYoutubeAnalysisDialog" width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>Average Youtube Analysis</v-card-title>
        <v-card-text class="mt-3 body-2">
          <v-hover v-slot:default="{ hover }">
            <v-card
              color="#363636"
              dark
              :elevation="hover ? 12 : 2"
              :class="{ 'mx-auto mb-5 text-center on-hover': hover, 'mx-auto mb-5 text-center': !hover}"
              style="width:300px"
            >
              <v-card-subtitle>
                <p
                  class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                >
                <span>Total Entries:</span><span>{{selectedYoutubeAnalysis.length}}</span>
                </p>
                <p
                  class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                >
                  <span>Outreach:</span>
                  <span>{{calYoutubeAvg('totalOutreach') === 0 ? '-' : calYoutubeAvg('totalOutreach')  | thousandSeprator}}</span>
                </p>
                <p
                  class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                >
                  <span>Total Views:</span>
                  <span>{{calYoutubeAvg('totalViews') === 0 ? '-' : calYoutubeAvg('totalViews')  | thousandSeprator}}</span>
                </p>
                <p
                  class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                >
                  <span>Likes:</span>
                  <span>{{calYoutubeAvg('totalLikes') === 0 ? '-' : calYoutubeAvg('totalLikes')  | thousandSeprator}}</span>
                </p>
                <p
                  class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                >
                  <span>Comments:</span>
                  <span>{{calYoutubeAvg('totalComments') === 0 ? '-' : calYoutubeAvg('totalComments')  | thousandSeprator}}</span>
                </p>
                <p
                  class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                >
                  <span>Interactions:</span>
                  <span>{{calYoutubeAvg('totalInteractions') === 0 ? '-' : calYoutubeAvg('totalInteractions')  | thousandSeprator}}</span>
                </p>
                <p
                  class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                >
                  <span>Average Views:</span>
                  <span>{{ calYoutubeAvg('totalAvgViews') === 0 ? '-' : calYoutubeAvg('totalAvgViews') | thousandSeprator }}</span>
                </p>
                <p
                  class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                >
                  <span>Average Likes:</span>
                  <span>{{ calYoutubeAvg('totalAvgLikes') === 0 ? '-' : calYoutubeAvg('totalAvgLikes') | thousandSeprator }}</span>
                </p>
                <p
                  class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                >
                  <span>Average Comments:</span>
                  <span>{{ calYoutubeAvg('totalAvgComments') === 0 ? '-' : calYoutubeAvg('totalAvgComments') | thousandSeprator }}</span>
                </p>
                <p
                  class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                >
                  <span>Engagement Rate by Interactions:</span>
                  <span>{{ calYoutubeAvg('totalEngagementRate') === 0 ? '-' : calYoutubeAvg('totalEngagementRate') + '%' }}</span>
                </p>
                <p
                  class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                >
                  <span>Engagement Rate by Views:</span>
                  <span>{{ calYoutubeAvg('totalEngagementRateView') === 0 ? '-' : calYoutubeAvg('totalEngagementRateView') + '%' }}</span>
                </p>
                <p
                  class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                >
                  <span>Average Engagement Rate:</span>
                  <span>{{ calYoutubeAvg('totalEngagementRateSd') === 0 ? '-' : calYoutubeAvg('totalEngagementRateSd') + '%' }}</span>
                </p>
                <p
                  class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                >
                  <span>Median Engagement Rate:</span>
                  <span>{{ calYoutubeAvg('totalMedianEngagementRate') === 0 ? '-' : calYoutubeAvg('totalMedianEngagementRate') + '%' }}</span>
                </p>
              </v-card-subtitle>
            </v-card>
          </v-hover>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" id="close" text @click.native="avgYoutubeAnalysisDialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- xhs cal avg dialog -->
    <v-dialog v-model="avgXhsAnalysisDialog" width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>Average XHS Analysis</v-card-title>
        <v-card-text class="mt-3 body-2">
          <v-hover v-slot:default="{ hover }">
            <v-card
              color="#363636"
              dark
              :elevation="hover ? 12 : 2"
              :class="{ 'mx-auto mb-5 text-center on-hover': hover, 'mx-auto mb-5 text-center': !hover}"
              style="width:300px"
            >
              <v-card-subtitle>
                <p
                  class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                >
                <span>Total Entries:</span><span>{{selectedXhsAnalysis.length}}</span>
                </p>
                <p
                  class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                >
                  <span>Outreach:</span>
                  <span>{{calXhsAvg('totalOutreach') === 0 ? '-' : calXhsAvg('totalOutreach')  | thousandSeprator}}</span>
                </p>
                <p
                  class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                >
                  <span>Likes:</span>
                  <span>{{calXhsAvg('totalLikes') === 0 ? '-' : calXhsAvg('totalLikes')  | thousandSeprator}}</span>
                </p>
                <p
                  class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                >
                  <span>Comments:</span>
                  <span>{{calXhsAvg('totalComments') === 0 ? '-' : calXhsAvg('totalComments')  | thousandSeprator}}</span>
                </p>
                <p
                  class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                >
                  <span>Views:</span>
                  <span>{{calXhsAvg('totalViews') === 0 ? '-' : calXhsAvg('totalViews')  | thousandSeprator}}</span>
                </p>
                <p
                  class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                >
                  <span>Shares:</span>
                  <span>{{calXhsAvg('totalShares') === 0 ? '-' : calXhsAvg('totalShares')  | thousandSeprator}}</span>
                </p>
                <p
                  class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                >
                  <span>Bookmarks:</span>
                  <span>{{calXhsAvg('totalBookmarks') === 0 ? '-' : calXhsAvg('totalBookmarks')  | thousandSeprator}}</span>
                </p>
                <p
                  class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                >
                  <span>Interactions:</span>
                  <span>{{calXhsAvg('totalInteractions') === 0 ? '-' : calXhsAvg('totalInteractions')  | thousandSeprator}}</span>
                </p>
              </v-card-subtitle>
            </v-card>
          </v-hover>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" id="close" text @click.native="avgXhsAnalysisDialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- facebook cal avg dialog -->
    <v-dialog v-model="avgFbAnalysisDialog" width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>Average Facebook Analysis</v-card-title>
        <v-card-text class="mt-3 body-2">
          <v-hover v-slot:default="{ hover }">
            <v-card
              color="#363636"
              dark
              :elevation="hover ? 12 : 2"
              :class="{ 'mx-auto mb-5 text-center on-hover': hover, 'mx-auto mb-5 text-center': !hover}"
              style="width:300px"
            >
              <v-card-subtitle>
                <p
                  class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                >
                <span>Total Entries:</span><span>{{selectedFbAnalysis.length}}</span>
                </p>
                <p
                  class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                >
                  <span>Outreach:</span>
                  <span>{{calFbAvg('totalOutreach') === 0 ? '-' : calFbAvg('totalOutreach')  | thousandSeprator}}</span>
                </p>
                <p
                  class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                >
                  <span>Likes:</span>
                  <span>{{calFbAvg('totalLikes') === 0 ? '-' : calFbAvg('totalLikes')  | thousandSeprator}}</span>
                </p>
                <p
                  class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                >
                  <span>Comments:</span>
                  <span>{{calFbAvg('totalComments') === 0 ? '-' : calFbAvg('totalComments')  | thousandSeprator}}</span>
                </p>
                <p
                  class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                >
                  <span>Views:</span>
                  <span>{{calFbAvg('totalViews') === 0 ? '-' : calFbAvg('totalViews')  | thousandSeprator}}</span>
                </p>
                <p
                  class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                >
                  <span>Shares:</span>
                  <span>{{calFbAvg('totalShares') === 0 ? '-' : calFbAvg('totalShares')  | thousandSeprator}}</span>
                </p>
                <p
                  class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                >
                  <span>Bookmarks:</span>
                  <span>{{calFbAvg('totalBookmarks') === 0 ? '-' : calFbAvg('totalBookmarks')  | thousandSeprator}}</span>
                </p>
                <p
                  class="pa-0 ma-0 custom-font text-left d-flex justify-space-between"
                >
                  <span>Interactions:</span>
                  <span>{{calFbAvg('totalInteractions') === 0 ? '-' : calFbAvg('totalInteractions')  | thousandSeprator}}</span>
                </p>
              </v-card-subtitle>
            </v-card>
          </v-hover>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" id="close" text @click.native="avgFbAnalysisDialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import utils from '@/utils'
import campaignHelper from '../campaignHelper';
import LegendIcon from '@/components/reports/LegendIcon'
import TableColsShowHideModal from '@/components/scoped/custom/TableColsShowHideModal'
import Loading from 'vue-loading-overlay';
import userAPIs from '../../User/userAPIs';
import campaignAPIs from '../../Campaign/campaignAPIs';
import statsConfig from './config';
export default {
  name: 'StatisticsAnalysisDataTable',
  props: ['viewHandle'],
  components: {
    LegendIcon,
    Loading,
    TableColsShowHideModal
  },
  watch: {
    viewHandle(newVal) {
      this.handle = newVal
      this.changeHandle()
    }
  },
  computed: {
    ...mapState({
      reports: state => state.campaign.reports
    }),
    currentUserRole() {
      return Number(this.$store.state.user.role)
    },
    computedPostTableHeaders() {
      let statsAnalysisPostCols = null
      // set col statuses from user table
      if (this.userProfile.tableSettings) {
        if (this.userProfile.tableSettings.statsAnalysisPostCols) {
          statsAnalysisPostCols = Object.assign({}, this.userProfile.tableSettings.statsAnalysisPostCols)
        }
      }
      if (statsAnalysisPostCols) {
        this.postColStatuses = Object.assign({}, statsAnalysisPostCols)
      } else {
        // default true if no col status in local storage
        this.postAnalysisTableHeaders.map(header => {
          this.postColStatuses[header.value] = true
        })
      }
      return this.postAnalysisTableHeaders.filter(h => {
        if (this.postColStatuses[h.value]) {
          return true
        }
        return false
      });
    },
    computedStoryTableHeaders() {
      let statsAnalysisStoryCols = null
      // set col statuses from user table
      if (this.userProfile.tableSettings) {
        if (this.userProfile.tableSettings.statsAnalysisStoryCols) {
          statsAnalysisStoryCols = Object.assign({}, this.userProfile.tableSettings.statsAnalysisStoryCols)
        }
      }
      if (statsAnalysisStoryCols) {
        this.storyColStatuses = Object.assign({}, statsAnalysisStoryCols)
      } else {
        // default true if no col status in local storage
        this.storyAnalysisTableHeaders.map(header => {
          this.storyColStatuses[header.value] = true
        })
      }
      return this.storyAnalysisTableHeaders.filter(h => {
        if (this.storyColStatuses[h.value]) {
          return true
        }
        return false
      });
    },
    computedReelTableHeaders() {
      let statsAnalysisReelCols = null
      // set col statuses from user table
      if (this.userProfile.tableSettings) {
        if (this.userProfile.tableSettings.statsAnalysisReelCols) {
          statsAnalysisReelCols = Object.assign({}, this.userProfile.tableSettings.statsAnalysisReelCols)
        }
      }
      if (statsAnalysisReelCols) {
        this.reelColStatuses = Object.assign({}, statsAnalysisReelCols)
      } else {
        // default true if no col status in local storage
        this.reelAnalysisTableHeaders.map(header => {
          this.reelColStatuses[header.value] = true
        })
      }
      return this.reelAnalysisTableHeaders.filter(h => {
        if (this.reelColStatuses[h.value]) {
          return true
        }
        return false
      });
    },
    computedTikTokTableHeaders() {
      let statsAnalysisTikTokCols = null
      // set col statuses from user table
      if (this.userProfile.tableSettings) {
        if (this.userProfile.tableSettings.statsAnalysisTikTokCols) {
          statsAnalysisTikTokCols = Object.assign({}, this.userProfile.tableSettings.statsAnalysisTikTokCols)
        }
      }
      if (statsAnalysisTikTokCols) {
        this.tiktokColStatuses = Object.assign({}, statsAnalysisTikTokCols)
      } else {
        // default true if no col status in local storage
        this.tiktokAnalysisTableHeaders.map(header => {
          this.tiktokColStatuses[header.value] = true
        })
      }
      return this.tiktokAnalysisTableHeaders.filter(h => {
        if (this.tiktokColStatuses[h.value]) {
          return true
        }
        return false
      });
    },
    computedYoutubeTableHeaders() {
      let statsAnalysisYoutubeCols = null
      // set col statuses from user table
      if (this.userProfile.tableSettings) {
        if (this.userProfile.tableSettings.statsAnalysisYoutubeCols) {
          statsAnalysisYoutubeCols = Object.assign({}, this.userProfile.tableSettings.statsAnalysisYoutubeCols)
        }
      }
      if (statsAnalysisYoutubeCols) {
        this.youtubeColStatuses = Object.assign({}, statsAnalysisYoutubeCols)
      } else {
        // default true if no col status in local storage
        this.youtubeAnalysisTableHeaders.map(header => {
          this.youtubeColStatuses[header.value] = true
        })
      }
      return this.youtubeAnalysisTableHeaders.filter(h => {
        if (this.youtubeColStatuses[h.value]) {
          return true
        }
        return false
      });
    },
    computedXHSTableHeaders() {
      let statsAnalysisXHSCols = null
      // set col statuses from user table
      if (this.userProfile.tableSettings) {
        if (this.userProfile.tableSettings.statsAnalysisXHSCols) {
          statsAnalysisXHSCols = Object.assign({}, this.userProfile.tableSettings.statsAnalysisXHSCols)
        }
      }
      if (statsAnalysisXHSCols) {
        this.xhsColStatuses = Object.assign({}, statsAnalysisXHSCols)
      } else {
        // default true if no col status in local storage
        this.xhsAnalysisTableHeaders.map(header => {
          this.xhsColStatuses[header.value] = true
        })
      }
      return this.xhsAnalysisTableHeaders.filter(h => {
        if (this.xhsColStatuses[h.value]) {
          return true
        }
        return false
      });
    },
    computedFbTableHeaders() {
      let statsAnalysisFbCols = null
      // set col statuses from user table
      if (this.userProfile.tableSettings) {
        if (this.userProfile.tableSettings.statsAnalysisFbCols) {
          statsAnalysisFbCols = Object.assign({}, this.userProfile.tableSettings.statsAnalysisFbCols)
        }
      }
      if (statsAnalysisFbCols) {
        this.fbColStatuses = Object.assign({}, statsAnalysisFbCols)
      } else {
        // default true if no col status in local storage
        this.fbAnalysisTableHeaders.map(header => {
          this.fbColStatuses[header.value] = true
        })
      }
      return this.fbAnalysisTableHeaders.filter(h => {
        if (this.fbColStatuses[h.value]) {
          return true
        }
        return false
      });
    },
    currentUserID: function() {
      return this.$store.state.user.id;
    },
    totalTikTokPlayTime() {
      let count = 0
      this.tiktokAnalysisData.map(item => {
        if (item.plays) {
          count += 1
        }
      })
      return campaignHelper.calculateTotalPlayTime(this.tiktokAnalysisData, count)
    },
    avgTikTokPlayTime() {
      let count = 0
      this.tiktokAnalysisData.map(item => {
        if (item.plays) {
          count += 1
        }
      })
      return campaignHelper.calculateTotalPlayTime(this.selectedTikTokAnalysis, count)
    },
    totalPlayTime() {
      let count = 0
      this.tiktokAnalysisData.map(item => {
        if (item.plays) {
          count += 1
        }
      })
      return campaignHelper.calculateTotalPlayTime(this.reelAnalysisData, count)
    },
    totalReelWatchTime() {
      let count = 0
      this.reelAnalysisData.map(item => {
        if (item.watches) {
          count += 1
        }
      })
      return campaignHelper.calculateTotalReelWatchTime(this.reelAnalysisData, count)
    },
    totalAvgPlayTime() {
      let count = 0
      this.tiktokAnalysisData.map(item => {
        if (item.plays) {
          count += 1
        }
      })
      return campaignHelper.calculateTotalPlayTime(this.selectedReelAnalysis, count)
    },
    totalAvgReelWatchTime() {
      let count = 0
      this.tiktokAnalysisData.map(item => {
        if (item.watches) {
          count += 1
        }
      })
      return campaignHelper.calculateTotalReelWatchTime(this.selectedReelAnalysis, count)
    }
  },
  data() {
    return {
      utils: utils.func,
      viewData: null,
      viewDialog: false,
      colSettingsDialog: false,
      colStatuses: {},
      postColStatuses: {},
      storyColStatuses: {},
      reelColStatuses: {},
      tiktokColStatuses: {},
      youtubeColStatuses: {},
      xhsColStatuses: {},
      fbColStatuses: {},
      userProfile: {},
      postAnalysisTableHeaders: statsConfig.postAnalysisTableHeaders,
      storyAnalysisTableHeaders: statsConfig.storyAnalysisTableHeaders,
      reelAnalysisTableHeaders: statsConfig.reelAnalysisTableHeaders,
      tiktokAnalysisTableHeaders: statsConfig.tiktokAnalysisTableHeaders,
      youtubeAnalysisTableHeaders: statsConfig.youtubeAnalysisTableHeaders,
      xhsAnalysisTableHeaders: statsConfig.xhsAnalysisTableHeaders,
      fbAnalysisTableHeaders: statsConfig.fbAnalysisTableHeaders,
      headers: [
        {
          text: '',
          value: 'contents'
        },
        {
          text: 'Live Date',
          value: 'live_date',
          legendText: 'Live Date'
        },
        {
          text: 'Outreach',
          value: 'outreach',
          legendText: 'The number of followers the creator has at the time where the post was made '
        },
        {
          text: 'Likes',
          value: 'likes',
          legendText: 'The number of times users have tapped the “like” button on a post.'
        },
        {
          text: 'Comments',
          value: 'comments',
          legendText: 'The number of written responses to a post.'
        },
        {
          text: 'Bookmarks',
          value: 'saved',
          legendText: 'The number of times users have saved a post to their “Saved” folder.'
        },
        {
          text: 'Shares',
          value: 'shares',
          legendText: 'The number of times users have reposted / shared a post.'
        },
        {
          text: 'Views',
          value: 'views',
          legendText: 'The number of times users have viewed a video for 3 seconds or more, not inclusive of looped views.'
        },
        {
          text: 'Reach',
          value: 'reach',
          legendText: 'The total number of unique users who viewed the content'
        },
        {
          text: 'Impressions',
          value: 'impressions',
          legendText: `The total number of times the content is displayed on an user's feed`
        },
        {
          text: 'Replies',
          value: 'replies',
          legendText: 'The number of replies to a story.'
        },
        {
          text: 'Links Click',
          value: 'link_clicks',
          legendText: 'The number of times users have tapped the link attached on a story.'
        },
        {
          text: 'Sticker Taps',
          value: 'sticker_taps',
          legendText: 'The number of times users have tapped the hashtags and mentions attached on a story.'
        },
        {
          text: 'Engagement Rate',
          value: 'new_engagement_rate',
          legendText: 'The total number of interactions (users who liked, commented, saved or shared the post) divided by the outreach numbers'
        },
        {
          text: 'Avg. Engagement Rate',
          value: 'engagement_rate_sd',
          legendText: 'The average sum of engagement rate on the last 30 posts'
        },
        {
          text: 'Median Engagement Rate',
          value: 'median_engagement_rate',
          legendText: 'The middle engagement rate amongst the sorted engagement rate of all the creator’ within same tier comparison.'
        },
        {
          text: 'Total Play Time',
          value: 'plays',
          legendText: 'The all-time data for how many total hours, minutes, and seconds this piece of content was viewed.'
        },
        {
          text: 'Average Watch Time',
          value: 'watches',
          legendText: 'How many seconds your video is viewed for'
        },
        {
          text: 'Average Likes',
          value: 'avg_likes',
          legendText: 'Average likes over the last 30 posts'
        },
        {
          text: 'Average Comments',
          value: 'avg_comments',
          legendText: 'Average comments over the last 30 posts'
        },
        {
          text: 'Average Views',
          value: 'avg_views',
          legendText: 'Average views over the last 30 posts'
        },
        {
          text: 'Average Reels Plays',
          value: 'avg_reels_plays',
          legendText: 'Average plays over the last 30 posts'
        }
      ],
      // creators: [
      //   {
      //     handle: 'sherlynchan',
      //     data: [
      //       {
      //         contentType: {
      //           name: 'igPost',
      //           title: 'IG Post'
      //         }
      //       },
      //       {
      //         campaign: {
      //           id: '1',
      //           name: 'UOB'
      //         },
      //         followers: 10,
      //         bookmarks: 20,
      //         shares: 10,
      //         linkClicks: 10,
      //         engagement: 20
      //       },
      //       {
      //         campaign: {
      //           id: '2',
      //           name: 'MSF'
      //         },
      //         followers: 10,
      //         bookmarks: 20,
      //         shares: 10,
      //         linkClicks: 10,
      //         engagement: 20
      //       }
      //     ]
      //   },
      //   {
      //     handle: 'heinko',
      //     data: [
      //       {
      //         contentType: {
      //           name: 'igCarousel',
      //           title: 'Carousel'
      //         }
      //       },
      //       {
      //         campaign: {
      //           id: '1',
      //           name: 'Pepsi'
      //         },
      //         followers: 10,
      //         bookmarks: 20,
      //         shares: 10,
      //         linkClicks: 10,
      //         engagement: 20
      //       },
      //       {
      //         campaign: {
      //           id: '2',
      //           name: 'Coke'
      //         },
      //         followers: 10,
      //         bookmarks: 15,
      //         shares: 10,
      //         linkClicks: 10,
      //         engagement: 20
      //       }
      //     ]
      //   }
      // ],
      creators: [],
      filter: '',
      normalReports: null,
      compareReports: null,
      isLoading: false,
      postAnalysisData: [],
      storyAnalysisData: [],
      reelAnalysisData: [],
      tiktokAnalysisData: [],
      youtubeAnalysisData: [],
      xhsAnalysisData: [],
      fbAnalysisData: [],
      selectedPostAnalysis: [],
      selectedStoryAnalysis: [],
      selectedReelAnalysis: [],
      selectedTikTokAnalysis: [],
      selectedYoutubeAnalysis: [],
      selectedXhsAnalysis: [],
      selectedFbAnalysis: [],
      avgPostAnalysisDialog: false,
      avgStoryAnalysisDialog: false,
      avgReelAnalysisDialog: false,
      avgTiktokAnalysisDialog: false,
      avgYoutubeAnalysisDialog: false,
      avgXhsAnalysisDialog: false,
      avgFbAnalysisDialog: false,
      updatingTableType: ''
    }
  },
  async mounted() {
    await this.getUserProfile()
  },
  methods: {
    async changeHandle() {
      if (!this.handle && !this.compareHandle) return
      this.isLoading = true
      let newCreators = [
        {
          index: 0,
          handle: this.handle
        },
        {
          index: 1,
          handle: this.compareHandle
        }
      ]
      for (let creator of newCreators) {
        if (creator.handle) {
          let handle = utils.func.espaceHandleSign(creator.handle)
          let oldData = null
          if (this.viewHandle) {
            oldData = await campaignAPIs.getStatsData(this.viewHandle)
            if (oldData.handle) {
              this.postAnalysisData = oldData.post || []
              this.storyAnalysisData = oldData.story || []
              this.reelAnalysisData = oldData.reel || []
              this.tiktokAnalysisData = oldData.tiktok || []
              this.youtubeAnalysisData = oldData.youtube || []
              this.xhsAnalysisData = oldData.xhs || []
              this.fbAnalysisData = oldData.fb || []
            }
          }
          if (!oldData || !oldData.handle) {
            // no stored stats doc (the API returns [] then) — compute fresh
            await this.$store.dispatch('campaign/getReportsByHandle', handle)
            this.formatReports(handle, creator.index)
          }
        } else {
          this.creators[creator.index] = null
        }
      }
      this.resetAnalysisData()
      this.isLoading = false
    },
    formatReports(handle, creatorIdx) {
      // let creatorData = []
      this.postAnalysisData = []
      this.storyAnalysisData = []
      this.reelAnalysisData = []
      this.tiktokAnalysisData = []
      this.youtubeAnalysisData = []
      this.xhsAnalysisData = []
      this.fbAnalysisData = []
      let posts = Object.assign([], this.reports)
      posts = posts.filter(p => !p.imported)
      posts = posts.map(p => {
        p = campaignHelper.calculatePostData(p, null)
        return p
      })
      for (let post of posts) {
        // let contentExists = creatorData.find(c => c.contentType && c.contentType.name === post.postType)
        // if (contentExists) {
        //   continue
        // }
        // set post type data
        // creatorData.push({
        //   contentType: {
        //     name: post.postType,
        //     title: post.title
        //   }
        // })
        // set related posts according to post type
        // let relatedPosts = posts.filter(rPost => rPost.postType === post.postType)
        let campaigns = []
        // turned off campaign grouping
        // let matchCampaignIdx = campaigns.findIndex(c => c.campaign.id === rPost.campaign.id)
        // if (matchCampaignIdx !== -1) {
        //   // if campaign already added, skip
        //   continue
        // }
        campaigns.push(post)
        // calc and set post stats data
        let matchCampaignIdx = campaigns.length - 1
        let campaignOne = campaigns[matchCampaignIdx]
        campaignOne.impressions = campaignOne.impressions || 0 // currently no used
        campaignOne.engagement = campaignOne.engagement || 0
        campaignOne.reach = campaignOne.reach || 0 // currently no used
        campaignOne.likes = campaignOne.likes || 0
        campaignOne.comments = campaignOne.comments || 0
        campaignOne.outreach = campaignOne.outreach || 0
        campaignOne.engagement_rate = campaignOne.engagement_rate || 0
        campaignOne.engagement_rate_sd = campaignOne.engagement_rate_sd || 0
        campaignOne.median_engagement_rate = campaignOne.median_engagement_rate || 0
        campaignOne.new_engagement_rate_view = campaignOne.new_engagement_rate_view || ''
        campaignOne.engagement_rate_reach = campaignOne.engagement_rate_reach || ''
        campaignOne.interactions = campaignOne.interactions || ''
        campaignOne.avg_likes = campaignOne.avg_likes || 0
        campaignOne.avg_comments = campaignOne.avg_comments || 0
        campaignOne.avg_views = campaignOne.avg_views || 0
        campaignOne.avg_reels_plays = campaignOne.avg_reels_plays || 0
        campaignOne.saved = campaignOne.saved || 0
        campaignOne.shares = campaignOne.shares || 0
        campaignOne.views = campaignOne.views || 0 // newly added views, so there could be null
        campaignOne.reach = campaignOne.reach || 0
        campaignOne.impressions = campaignOne.impressions || 0
        campaignOne.replies = campaignOne.replies || 0
        campaignOne.exits = campaignOne.exits || 0
        campaignOne.taps_back = campaignOne.taps_back || 0
        campaignOne.taps_forward = campaignOne.taps_forward || 0
        campaignOne.sticker_taps = campaignOne.sticker_taps || 0
        campaignOne.link_clicks = campaignOne.link_clicks || 0
        campaignOne.storyTotalInteractions = campaignOne.storyTotalInteractions || 0
        campaignOne.plays = campaignOne.plays || 0
        campaignOne.watches = campaignOne.watches || 0
        campaignOne.watchedFullVideo = campaignOne.watchedFullVideo || 0
        // turned off ---- sum up related posts data in same campaign
        // for (let postData of relatedPosts) {
        //   if (postData.id === campaignOne.id || postData.campaign.id !== campaignOne.campaign.id) {
        //     // if current post, skip (coz need to sum up with other same campaign posts)
        //     continue;
        //   }
        //   if (postData.impressions) campaignOne.impressions += postData.impressions
        //   if (postData.engagement) campaignOne.engagement += postData.engagement
        //   if (postData.reach) campaignOne.reach += postData.reach
        //   if (postData.likes) campaignOne.likes += postData.likes
        //   if (postData.comments) campaignOne.comments += postData.comments
        //   if (postData.avg_likes) campaignOne.avg_likes += postData.avg_likes
        //   if (postData.avg_comments) campaignOne.avg_comments += postData.avg_comments
        //   if (postData.avg_views) campaignOne.avg_views += postData.avg_views
        //   if (postData.avg_reels_plays) campaignOne.avg_reels_plays += postData.avg_reels_plays
        //   if (postData.saved) campaignOne.saved += postData.saved
        //   if (postData.shares) campaignOne.shares += postData.shares
        //   if (postData.views) campaignOne.views += postData.views
        //   if (postData.reach) campaignOne.reach += postData.reach
        //   if (postData.impressions) campaignOne.impressions += postData.impressions
        //   if (postData.replies) campaignOne.replies += postData.replies
        //   if (postData.exits) campaignOne.exits += postData.exits
        //   if (postData.taps_back) campaignOne.taps_back += postData.taps_back
        //   if (postData.taps_forward) campaignOne.taps_forward += postData.taps_forward
        //   if (postData.sticker_taps) campaignOne.sticker_taps += postData.sticker_taps
        //   if (postData.link_clicks) campaignOne.link_clicks += postData.link_clicks
        //   if (postData.storyTotalInteractions) campaignOne.storyTotalInteractions += postData.storyTotalInteractions
        //   if (postData.plays) campaignOne.plays += postData.plays
        //   if (postData.watches) campaignOne.watches += postData.watches
        // }
        campaigns[matchCampaignIdx] = Object.assign({}, campaignOne)
        if (campaignOne.type === 'post/carousel') {
          this.postAnalysisData.push(campaignOne)
        }
        if (campaignOne.type === 'reel') {
          this.reelAnalysisData.push(campaignOne)
        }
        if (campaignOne.type === 'story' || campaignOne.type === 'gdrive') {
          this.storyAnalysisData.push(campaignOne)
        }
        if (campaignOne.type === 'tiktok') {
          this.tiktokAnalysisData.push(campaignOne)
        }
        if (campaignOne.type === 'youtube') {
          this.youtubeAnalysisData.push(campaignOne)
        }
        if (campaignOne.type === 'xhs') {
          this.xhsAnalysisData.push(campaignOne)
        }
        if (campaignOne.type === 'facebook') {
          this.fbAnalysisData.push(campaignOne)
        }
      }
      this.storeStatsData({
        handle
      })
      // this.creators[creatorIdx] = {
      //   handle,
      //   data: creatorData
      // }
    },
    getRowClass(item) {
      if (item.contentType) {
        return 'row-content'
      } else {
        return 'row-campaign'
      }
    },
    showTikTokPlayTime(time) {
      return campaignHelper.showTikTokPlayTime(time)
    },
    showReelPlayTime(time) {
      return campaignHelper.showReelPlayTime(time)
    },
    openColSettingsModal(type) {
      this.updatingTableType = type
      this.tableColsItems = []
      let tmpStatuses = {}
      if (type === 'post') {
        if (Object.keys(this.postColStatuses).length) {
          tmpStatuses = Object.assign({}, this.postColStatuses)
        } else {
          this.postAnalysisTableHeaders.map(header => {
            tmpStatuses[header.value] = true
          })
        }
        // eslint-disable-next-line
        for (const [key, value] of Object.entries(this.postAnalysisTableHeaders)) {
          if (value.text) {
            this.tableColsItems.push({
              title: value.text,
              key: value.value,
              value: tmpStatuses[value.value] ? tmpStatuses[value.value] : false
            })
          }
        }
      }
      if (type === 'story') {
        if (Object.keys(this.storyColStatuses).length) {
          tmpStatuses = Object.assign({}, this.storyColStatuses)
        } else {
          this.storyAnalysisTableHeaders.map(header => {
            tmpStatuses[header.value] = true
          })
        }
        // eslint-disable-next-line
        for (const [key, value] of Object.entries(this.storyAnalysisTableHeaders)) {
          if (value.text) {
            this.tableColsItems.push({
              title: value.text,
              key: value.value,
              value: tmpStatuses[value.value] ? tmpStatuses[value.value] : false
            })
          }
        }
      }
      if (type === 'reel') {
        if (Object.keys(this.reelColStatuses).length) {
          tmpStatuses = Object.assign({}, this.reelColStatuses)
        } else {
          this.reelAnalysisTableHeaders.map(header => {
            tmpStatuses[header.value] = true
          })
        }
        // eslint-disable-next-line
        for (const [key, value] of Object.entries(this.reelAnalysisTableHeaders)) {
          if (value.text) {
            this.tableColsItems.push({
              title: value.text,
              key: value.value,
              value: tmpStatuses[value.value] ? tmpStatuses[value.value] : false
            })
          }
        }
      }
      if (type === 'tiktok') {
        if (Object.keys(this.tiktokColStatuses).length) {
          tmpStatuses = Object.assign({}, this.tiktokColStatuses)
        } else {
          this.tiktokAnalysisTableHeaders.map(header => {
            tmpStatuses[header.value] = true
          })
        }
        // eslint-disable-next-line
        for (const [key, value] of Object.entries(this.tiktokAnalysisTableHeaders)) {
          if (value.text) {
            this.tableColsItems.push({
              title: value.text,
              key: value.value,
              value: tmpStatuses[value.value] ? tmpStatuses[value.value] : false
            })
          }
        }
      }
      if (type === 'youtube') {
        if (Object.keys(this.youtubeColStatuses).length) {
          tmpStatuses = Object.assign({}, this.youtubeColStatuses)
        } else {
          this.youtubeAnalysisTableHeaders.map(header => {
            tmpStatuses[header.value] = true
          })
        }
        // eslint-disable-next-line
        for (const [key, value] of Object.entries(this.youtubeAnalysisTableHeaders)) {
          if (value.text) {
            this.tableColsItems.push({
              title: value.text,
              key: value.value,
              value: tmpStatuses[value.value] ? tmpStatuses[value.value] : false
            })
          }
        }
      }
      if (type === 'xhs') {
        if (Object.keys(this.xhsColStatuses).length) {
          tmpStatuses = Object.assign({}, this.xhsColStatuses)
        } else {
          this.xhsAnalysisTableHeaders.map(header => {
            tmpStatuses[header.value] = true
          })
        }
        // eslint-disable-next-line
        for (const [key, value] of Object.entries(this.xhsAnalysisTableHeaders)) {
          if (value.text) {
            this.tableColsItems.push({
              title: value.text,
              key: value.value,
              value: tmpStatuses[value.value] ? tmpStatuses[value.value] : false
            })
          }
        }
      }
      if (type === 'facebook') {
        if (Object.keys(this.fbColStatuses).length) {
          tmpStatuses = Object.assign({}, this.fbColStatuses)
        } else {
          this.fbAnalysisTableHeaders.map(header => {
            tmpStatuses[header.value] = true
          })
        }
        // eslint-disable-next-line
        for (const [key, value] of Object.entries(this.fbAnalysisTableHeaders)) {
          if (value.text) {
            this.tableColsItems.push({
              title: value.text,
              key: value.value,
              value: tmpStatuses[value.value] ? tmpStatuses[value.value] : false
            })
          }
        }
      }
      this.colSettingsDialog = true
    },
    async updateTableCols(items) {
      let tableSettings = {}
      if (this.updatingTableType === 'post') {
        let columns = this.postColStatuses
        items.map(item => {
          columns[item.key] = item.value
        })
        if (this.userProfile.tableSettings) {
          tableSettings = this.userProfile.tableSettings
        }
        tableSettings.statsAnalysisPostCols = Object.assign({}, columns)
        this.postColStatuses = Object.assign({}, columns)
      }
      if (this.updatingTableType === 'story') {
        let columns = this.storyColStatuses
        items.map(item => {
          columns[item.key] = item.value
        })
        if (this.userProfile.tableSettings) {
          tableSettings = this.userProfile.tableSettings
        }
        tableSettings.statsAnalysisStoryCols = Object.assign({}, columns)
        this.storyColStatuses = Object.assign({}, columns)
      }
      if (this.updatingTableType === 'reel') {
        let columns = this.reelColStatuses
        items.map(item => {
          columns[item.key] = item.value
        })
        if (this.userProfile.tableSettings) {
          tableSettings = this.userProfile.tableSettings
        }
        tableSettings.statsAnalysisReelCols = Object.assign({}, columns)
        this.reelColStatuses = Object.assign({}, columns)
      }
      if (this.updatingTableType === 'tiktok') {
        let columns = this.tiktokColStatuses
        items.map(item => {
          columns[item.key] = item.value
        })
        if (this.userProfile.tableSettings) {
          tableSettings = this.userProfile.tableSettings
        }
        tableSettings.statsAnalysisTikTokCols = Object.assign({}, columns)
        this.tiktokColStatuses = Object.assign({}, columns)
      }
      if (this.updatingTableType === 'youtube') {
        let columns = this.youtubeColStatuses
        items.map(item => {
          columns[item.key] = item.value
        })
        if (this.userProfile.tableSettings) {
          tableSettings = this.userProfile.tableSettings
        }
        tableSettings.statsAnalysisYoutubeCols = Object.assign({}, columns)
        this.youtubeColStatuses = Object.assign({}, columns)
      }
      if (this.updatingTableType === 'xhs') {
        let columns = this.xhsColStatuses
        items.map(item => {
          columns[item.key] = item.value
        })
        if (this.userProfile.tableSettings) {
          tableSettings = this.userProfile.tableSettings
        }
        tableSettings.statsAnalysisXHSCols = Object.assign({}, columns)
        this.xhsColStatuses = Object.assign({}, columns)
      }
      if (this.updatingTableType === 'facebook') {
        let columns = this.fbColStatuses
        items.map(item => {
          columns[item.key] = item.value
        })
        if (this.userProfile.tableSettings) {
          tableSettings = this.userProfile.tableSettings
        }
        tableSettings.statsAnalysisFbCols = Object.assign({}, columns)
        this.fbColStatuses = Object.assign({}, columns)
      }
      let updateData = {
        id: this.currentUserID,
        tableSettings
      }
      await userAPIs.editUser(updateData)
      // localStorage.setItem('MasterListCols', JSON.stringify(columns))
      this.colSettingsDialog = false
    },
    async getUserProfile() {
      let resp = await userAPIs.getUser(this.currentUserID)
      if (resp && resp.id) {
        this.userProfile = resp
      }
    },
    displayFields(fieldName) {
      if (this.colStatuses[fieldName]) return true
      return false
    },
    getUpdateColTitle() {
      if (this.updatingTableType === 'post') {
        return 'Post Analysis Summary'
      }
      if (this.updatingTableType === 'story') {
        return 'Story Analysis Summary'
      }
      if (this.updatingTableType === 'reel') {
        return 'Reel Analysis Summary'
      }
      if (this.updatingTableType === 'tiktok') {
        return 'TikTok Analysis Summary'
      }
      if (this.updatingTableType === 'youtube') {
        return 'Youtube Analysis Summary'
      }
      if (this.updatingTableType === 'xhs') {
        return 'XHS Analysis Summary'
      }
      if (this.updatingTableType === 'facebook') {
        return 'Facebook Analysis Summary'
      }
    },
    calPostTotal(field) {
      if (field === 'totalOutreach') {
        let outreach = 0;
        let count = 0
        this.postAnalysisData.map(item => {
          outreach += item.outreach ? item.outreach : 0
          if (item.outreach > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (outreach / count).toFixed(0)
        }
        return outreach
      }
      if (field === 'totalReach') {
        let reach = 0;
        let count = 0
        this.postAnalysisData.map(item => {
          reach += item.reach ? item.reach : 0
          if (item.reach > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (reach / count).toFixed(0)
        }
        return reach
      }
      if (field === 'totalImpressions') {
        let impressions = 0;
        let count = 0
        this.postAnalysisData.map(item => {
          impressions += item.impressions ? item.impressions : 0
          if (item.impressions > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (impressions / count).toFixed(0)
        }
        return impressions
      }
      if (field === 'totalLikes') {
        let likes = 0;
        let count = 0
        this.postAnalysisData.map(item => {
          likes += item.likes ? item.likes : 0
          if (item.likes > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (likes / count).toFixed(0)
        }
        return likes
      }
      if (field === 'totalShares') {
        let shares = 0
        let count = 0
        this.postAnalysisData.map(item => {
          shares += item.shares ? item.shares : 0
          if (item.shares > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (shares / count).toFixed(0)
        }
        return shares
      }
      if (field === 'totalComments') {
        let comments = 0;
        let count = 0
        this.postAnalysisData.map(item => {
          comments += item.comments ? item.comments : 0
          if (item.comments > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (comments / count).toFixed(0)
        }
        return comments
      }
      if (field === 'totalSaved') {
        let saved = 0;
        let count = 0
        this.postAnalysisData.map(item => {
          saved += item.saved ? item.saved : 0
          if (item.saved > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (saved / count).toFixed(0)
        }
        return saved
      }
      if (field === 'totalInteractions') {
        let interactions = 0;
        let count = 0;
        this.postAnalysisData.map(item => {
          interactions += item.interactions ? item.interactions : 0
          if (item.interactions > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (interactions / count).toFixed(0)
        }
        return interactions
      }
      if (field === 'totalViews') {
        let views = 0;
        let count = 0;
        this.postAnalysisData.map(item => {
          views += item.views ? item.views : 0
          if (item.views > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (views / count).toFixed(0)
        }
        return views
      }
      if (field === 'totalEngagementRate') {
        let engTotal = 0;
        let count = 0;
        this.postAnalysisData.map(item => {
          engTotal += item.new_engagement_rate ? item.new_engagement_rate : 0
          if (item.new_engagement_rate > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (engTotal / count).toFixed(2)
        }
        return engTotal
      }
      if (field === 'totalEngagementRateView') {
        let engTotal = 0;
        let count = 0;
        this.postAnalysisData.map(item => {
          engTotal += item.new_engagement_rate_view ? item.new_engagement_rate_view : 0
          if (item.new_engagement_rate_view > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (engTotal / count).toFixed(2)
        }
        return engTotal
      }
      if (field === 'totalEngagementRateReach') {
        let engTotal = 0;
        let count = 0;
        this.postAnalysisData.map(item => {
          engTotal += item.engagement_rate_reach ? item.engagement_rate_reach : 0
          if (item.engagement_rate_reach > 0) {
            count += 1
          }
        })
        if (count > 0 && engTotal > 0) {
          return (engTotal / count).toFixed(2)
        }
        return engTotal
      }
      if (field === 'totalEngRateSd') {
        let engTotal = 0;
        let count = 0;
        this.postAnalysisData.map(item => {
          engTotal += item.engagement_rate_sd ? Number(item.engagement_rate_sd) : 0
          if (Number(item.engagement_rate_sd) > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (engTotal / count).toFixed(2)
        }
        return engTotal
      }
      if (field === 'totalMedianEngRate') {
        let engTotal = 0;
        let count = 0;
        this.postAnalysisData.map(item => {
          engTotal += item.median_engagement_rate ? item.median_engagement_rate : 0
          if (item.median_engagement_rate > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (engTotal / count).toFixed(2)
        }
        return engTotal
      }
      if (field === 'totalAvgLikes') {
        let engTotal = 0;
        let count = 0;
        this.postAnalysisData.map(item => {
          engTotal += item.avg_likes ? item.avg_likes : 0
          if (item.avg_likes > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (engTotal / count).toFixed(2)
        }
        return engTotal
      }
      if (field === 'totalAvgComments') {
        let engTotal = 0;
        let count = 0;
        this.postAnalysisData.map(item => {
          engTotal += item.avg_comments ? item.avg_comments : 0
          if (item.avg_comments > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (engTotal / count).toFixed(2)
        }
        return engTotal
      }
      if (field === 'totalAvgViews') {
        let engTotal = 0;
        let count = 0;
        this.postAnalysisData.map(item => {
          engTotal += item.avg_views ? item.avg_views : 0
          if (item.avg_views > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (engTotal / count).toFixed(2)
        }
        return engTotal
      }
    },
    calStoryTotal(field) {
      if (field === 'totalOutreach') {
        let outreach = 0;
        let count = 0
        this.storyAnalysisData.map(item => {
          outreach += item.outreach ? item.outreach : 0
          if (item.outreach > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (outreach / count).toFixed(0)
        }
        return outreach
      }
      if (field === 'totalReach') {
        let reach = 0;
        let count = 0
        this.storyAnalysisData.map(item => {
          reach += item.reach ? item.reach : 0
          if (item.reach > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (reach / count).toFixed(0)
        }
        return reach
      }
      if (field === 'totalImpressions') {
        let impressions = 0;
        let count = 0
        this.storyAnalysisData.map(item => {
          impressions += item.impressions ? item.impressions : 0
          if (item.impressions > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (impressions / count).toFixed(0)
        }
        return impressions
      }
      if (field === 'totalReplies') {
        let replies = 0;
        let count = 0;
        this.storyAnalysisData.map(item => {
          replies += item.replies ? item.replies : 0
          if (item.replies > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (replies / count).toFixed(0)
        }
        return replies
      }
      if (field === 'totalShares') {
        let shares = 0;
        let count = 0;
        this.storyAnalysisData.map(item => {
          shares += item.shares ? item.shares : 0
          if (item.shares > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (shares / count).toFixed(0)
        }
        return shares
      }
      if (field === 'totalLinkClicks') {
        let linkClicks = 0;
        let count = 0
        this.storyAnalysisData.map(item => {
          linkClicks += item.link_clicks ? item.link_clicks : 0
          if (item.link_clicks > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (linkClicks / count).toFixed(0)
        }
        return linkClicks
      }
      if (field === 'totalStickerTaps') {
        let stickerTaps = 0
        let count = 0
        this.storyAnalysisData.map(item => {
          stickerTaps += item.sticker_taps ? item.sticker_taps : 0
          if (item.sticker_taps > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (stickerTaps / count).toFixed(0)
        }
        return stickerTaps
      }
      if (field === 'totalInteractions') {
        let interactions = 0;
        let count = 0;
        this.storyAnalysisData.map(item => {
          interactions += item.interactions ? item.interactions : 0
          if (item.interactions > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (interactions / count).toFixed(0)
        }
        return interactions
      }
      if (field === 'totalAvgViews') {
        let calData = 0;
        let count = 0;
        this.storyAnalysisData.map(item => {
          calData += item.avg_views ? item.avg_views : 0
          if (item.avg_views > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (calData / count).toFixed(0)
        }
        return calData
      }
      if (field === 'totalAvgReelPlays') {
        let calData = 0;
        let count = 0;
        this.storyAnalysisData.map(item => {
          calData += item.avg_reels_plays ? item.avg_reels_plays : 0
          if (item.avg_reels_plays > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (calData / count).toFixed(0)
        }
        return calData
      }
    },
    calReelTotal(field) {
      if (field === 'totalOutreach') {
        let outreach = 0;
        let count = 0
        this.reelAnalysisData.map(item => {
          outreach += item.outreach ? item.outreach : 0
          if (item.outreach > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (outreach / count).toFixed(0)
        }
        return outreach
      }
      if (field === 'totalReach') {
        let reach = 0;
        let count = 0
        this.reelAnalysisData.map(item => {
          reach += item.reach ? item.reach : 0
          if (reach > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (reach / count).toFixed(0)
        }
        return reach
      }
      if (field === 'totalImpressions') {
        let impressions = 0;
        let count = 0
        this.reelAnalysisData.map(item => {
          impressions += item.impressions ? item.impressions : 0
          if (impressions > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (impressions / count).toFixed(0)
        }
        return impressions
      }
      if (field === 'totalLikes') {
        let likes = 0;
        let count = 0
        this.reelAnalysisData.map(item => {
          likes += item.likes ? item.likes : 0
          if (item.likes > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (likes / count).toFixed(0)
        }
        return likes
      }
      if (field === 'totalShares') {
        let shares = 0;
        let count = 0
        this.reelAnalysisData.map(item => {
          shares += item.shares ? item.shares : 0
          if (item.shares > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (shares / count).toFixed(0)
        }
        return shares
      }
      if (field === 'totalComments') {
        let comments = 0;
        let count = 0
        this.reelAnalysisData.map(item => {
          comments += item.comments ? item.comments : 0
          if (item.comments > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (comments / count).toFixed(0)
        }
        return comments
      }
      if (field === 'totalSaved') {
        let saved = 0;
        let count = 0
        this.reelAnalysisData.map(item => {
          saved += item.saved ? item.saved : 0
          if (item.saved > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (saved / count).toFixed(0)
        }
        return saved
      }
      if (field === 'totalInteractions') {
        let interactions = 0;
        let count = 0
        this.reelAnalysisData.map(item => {
          interactions += item.interactions ? item.interactions : 0
          if (item.interactions > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (interactions / count).toFixed(0)
        }
        return interactions
      }
      if (field === 'totalViews') {
        let views = 0;
        let count = 0
        this.reelAnalysisData.map(item => {
          views += item.views ? item.views : 0
          if (item.views > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (views / count).toFixed(0)
        }
        return views
      }
      if (field === 'totalEngagementRate') {
        let engRate = 0;
        let count = 0
        this.reelAnalysisData.map(item => {
          engRate += item.new_engagement_rate ? item.new_engagement_rate : 0
          if (item.new_engagement_rate > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (engRate / count).toFixed(2)
        }
        return engRate
      }
      if (field === 'totalEngagementRateView') {
        let engRate = 0
        let count = 0
        this.reelAnalysisData.map(item => {
          engRate += item.new_engagement_rate_view ? item.new_engagement_rate_view : 0
          if (item.new_engagement_rate_view > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (engRate / count).toFixed(2)
        }
        return engRate
      }
      if (field === 'totalInteractionRatePlays') {
        let engRate = 0;
        let count = 0
        this.reelAnalysisData.map(item => {
          engRate += item.interaction_rate_plays ? item.interaction_rate_plays : 0
          if (item.interaction_rate_plays > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (engRate / count).toFixed(2)
        }
        return engRate
      }
      if (field === 'totalEngagementRateReach') {
        let engRate = 0;
        let count = 0
        this.reelAnalysisData.map(item => {
          engRate += item.engagement_rate_reach ? item.engagement_rate_reach : 0
          if (item.engagement_rate_reach > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (engRate / count).toFixed(2)
        }
        return engRate
      }
      if (field === 'totalEngRateSd') {
        let engRate = 0;
        let count = 0
        this.reelAnalysisData.map(item => {
          engRate += item.engagement_rate_sd ? Number(item.engagement_rate_sd) : 0
          if (item.engagement_rate_sd > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (engRate / count).toFixed(2)
        }
        return engRate
      }
      if (field === 'totalMedianEngRate') {
        let engRate = 0;
        let count = 0
        this.reelAnalysisData.map(item => {
          engRate += item.median_engagement_rate ? item.median_engagement_rate : 0
          if (item.median_engagement_rate > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (engRate / count).toFixed(2)
        }
        return engRate
      }
      if (field === 'totalMedianEngRate') {
        let engRate = 0;
        let count = 0
        this.reelAnalysisData.map(item => {
          engRate += item.median_engagement_rate ? item.median_engagement_rate : 0
          if (item.median_engagement_rate > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (engRate / count).toFixed(2)
        }
        return engRate
      }
      if (field === 'totalAvgLikes') {
        let engRate = 0;
        let count = 0
        this.reelAnalysisData.map(item => {
          engRate += item.avg_likes ? item.avg_likes : 0
          if (item.avg_likes > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (engRate / count).toFixed(2)
        }
        return engRate
      }
      if (field === 'totalAvgComments') {
        let engRate = 0;
        let count = 0
        this.reelAnalysisData.map(item => {
          engRate += item.avg_comments ? item.avg_comments : 0
          if (item.avg_comments > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (engRate / count).toFixed(2)
        }
        return engRate
      }
      if (field === 'totalAvgViews') {
        let engRate = 0;
        let count = 0
        this.reelAnalysisData.map(item => {
          engRate += item.avg_views ? item.avg_views : 0
          if (item.avg_views > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (engRate / count).toFixed(2)
        }
        return engRate
      }
      if (field === 'totalReelPlays') {
        let engRate = 0;
        let count = 0
        this.reelAnalysisData.map(item => {
          engRate += item.avg_reels_plays ? item.avg_reels_plays : 0
          if (item.avg_reels_plays > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (engRate / count).toFixed(2)
        }
        return engRate
      }
    },
    calTikTokTotal(field) {
      if (field === 'totalOutreach') {
        let outreach = 0;
        let count = 0
        this.tiktokAnalysisData.map(item => {
          outreach += item.outreach ? item.outreach : 0
          if (item.outreach > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (outreach / count).toFixed(0)
        }
        return outreach
      }
      if (field === 'totalWatches') {
        let watches = 0;
        let count = 0
        this.tiktokAnalysisData.map(item => {
          watches += item.watches ? campaignHelper.formatWatchTime(item.watches) : 0
          if (item.watches) {
            count += 1
          }
        })
        if (count > 0) {
          return (watches / count).toFixed(2) + 's'
        }
        return `${watches}s`
      }
      if (field === 'totalLikes') {
        let likes = 0;
        let count = 0
        this.tiktokAnalysisData.map(item => {
          likes += item.likes ? item.likes : 0
          if (item.likes > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (likes / count).toFixed(0)
        }
        return likes
      }
      if (field === 'totalComments') {
        let comments = 0;
        let count = 0
        this.tiktokAnalysisData.map(item => {
          comments += item.comments ? item.comments : 0
          if (item.comments > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (comments / count).toFixed(0)
        }
        return comments
      }
      if (field === 'totalShares') {
        let shares = 0;
        let count = 0
        this.tiktokAnalysisData.map(item => {
          shares += item.shares ? item.shares : 0
          if (item.shares > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (shares / count).toFixed(0)
        }
        return shares
      }
      if (field === 'totalBookmarks') {
        let saved = 0;
        let count = 0
        this.tiktokAnalysisData.map(item => {
          saved += item.saved ? item.saved : 0
          if (item.saved > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (saved / count).toFixed(0)
        }
        return saved
      }
      if (field === 'totalInteractions') {
        let interactions = 0;
        let count = 0
        this.tiktokAnalysisData.map(item => {
          interactions += item.interactions ? item.interactions : 0
          if (item.interactions > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (interactions / count).toFixed(0)
        }
        return interactions
      }
      if (field === 'totalViews') {
        let views = 0;
        let count = 0
        this.tiktokAnalysisData.map(item => {
          views += item.views ? item.views : 0
          if (item.views > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (views / count).toFixed(0)
        }
        return views
      }
      if (field === 'totalReach') {
        let reach = 0;
        let count = 0
        this.tiktokAnalysisData.map(item => {
          reach += item.reach ? item.reach : 0
          if (item.reach > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (reach / count).toFixed(0)
        }
        return reach
      }
      if (field === 'totalImpressions') {
        let impressions = 0;
        let count = 0
        this.tiktokAnalysisData.map(item => {
          impressions += item.impressions ? item.impressions : 0
          if (item.impressions > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (impressions / count).toFixed(0)
        }
        return impressions
      }
      if (field === 'totalAvgViews') {
        let calData = 0;
        let count = 0
        this.tiktokAnalysisData.map(item => {
          calData += item.avg_views ? item.avg_views : 0
          if (item.avg_views > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (calData / count).toFixed(2)
        }
        return calData
      }
      if (field === 'totalAvgLikes') {
        let calData = 0;
        let count = 0
        this.tiktokAnalysisData.map(item => {
          calData += item.avg_likes ? item.avg_likes : 0
          if (item.avg_likes > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (calData / count).toFixed(2)
        }
        return calData
      }
      if (field === 'totalAvgComments') {
        let calData = 0;
        let count = 0
        this.tiktokAnalysisData.map(item => {
          calData += item.avg_comments ? item.avg_comments : 0
          if (item.avg_comments > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (calData / count).toFixed(2)
        }
        return calData
      }
      if (field === 'totalAvgSaves') {
        let calData = 0;
        let count = 0
        this.tiktokAnalysisData.map(item => {
          calData += item.avg_saves ? item.avg_saves : 0
          if (item.avg_saves > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (calData / count).toFixed(2)
        }
        return calData
      }
      if (field === 'totalAvgShares') {
        let calData = 0;
        let count = 0
        this.tiktokAnalysisData.map(item => {
          calData += item.avg_saves ? item.avg_saves : 0
          if (item.avg_saves > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (calData / count).toFixed(2)
        }
        return calData
      }
      if (field === 'totalEngagementRate') {
        let engRate = 0;
        let count = 0
        this.tiktokAnalysisData.map(item => {
          engRate += item.new_engagement_rate ? item.new_engagement_rate : 0
          if (item.new_engagement_rate > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (engRate / count).toFixed(2)
        }
        return engRate
      }
      if (field === 'totalEngagementRateView') {
        let engRate = 0;
        let count = 0
        this.tiktokAnalysisData.map(item => {
          engRate += item.new_engagement_rate_view ? item.new_engagement_rate_view : 0
          if (item.new_engagement_rate_view > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (engRate / count).toFixed(2)
        }
        return engRate
      }
      if (field === 'totalInteractionRatePlays') {
        let engRate = 0;
        let count = 0
        this.tiktokAnalysisData.map(item => {
          engRate += item.interaction_rate_plays ? item.interaction_rate_plays : 0
          if (item.interaction_rate_plays > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (engRate / count).toFixed(0)
        }
        return engRate
      }
      if (field === 'totalEngRateTotalViewers') {
        let engRate = 0;
        let count = 0
        this.tiktokAnalysisData.map(item => {
          engRate += item.eng_rate_total_viewers ? item.eng_rate_total_viewers : 0
          if (item.eng_rate_total_viewers > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (engRate / count).toFixed(2)
        }
        return engRate
      }
      if (field === 'totalEngRateSd') {
        let engRate = 0;
        let count = 0
        this.tiktokAnalysisData.map(item => {
          engRate += item.engagement_rate_sd ? item.engagement_rate_sd : 0
          if (item.engagement_rate_sd > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (engRate / count).toFixed(2)
        }
        return engRate
      }
      if (field === 'totalMedianEngRateSd') {
        let engRate = 0;
        let count = 0
        this.tiktokAnalysisData.map(item => {
          engRate += item.median_engagement_rate ? item.median_engagement_rate : 0
          if (item.median_engagement_rate > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (engRate / count).toFixed(2)
        }
        return engRate
      }
      if (field === 'totalWatchedFullVideo') {
        let engRate = 0;
        let count = 0
        this.tiktokAnalysisData.map(item => {
          engRate += item.watchedFullVideo ? item.watchedFullVideo : 0
          if (item.watchedFullVideo > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (engRate / count).toFixed(2)
        }
        return engRate
      }
    },
    calYoutubeTotal(field) {
      if (field === 'totalOutreach') {
        let outreach = 0;
        let count = 0
        this.youtubeAnalysisData.map(item => {
          outreach += item.outreach ? item.outreach : 0
          if (item.outreach > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (outreach / count).toFixed(0)
        }
        return outreach
      }
      if (field === 'totalViews') {
        let calData = 0;
        let count = 0
        this.youtubeAnalysisData.map(item => {
          calData += item.views ? item.views : 0
          if (item.views > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (calData / count).toFixed(0)
        }
        return calData
      }
      if (field === 'totalLikes') {
        let calData = 0;
        let count = 0
        this.youtubeAnalysisData.map(item => {
          calData += item.likes ? item.likes : 0
          if (item.likes > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (calData / count).toFixed(0)
        }
        return calData
      }
      if (field === 'totalComments') {
        let calData = 0;
        let count = 0
        this.youtubeAnalysisData.map(item => {
          calData += item.comments ? item.comments : 0
          if (item.comments > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (calData / count).toFixed(0)
        }
        return calData
      }
      if (field === 'totalInteractions') {
        let calData = 0;
        let count = 0
        this.youtubeAnalysisData.map(item => {
          calData += item.interactions ? item.interactions : 0
          if (item.interactions > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (calData / count).toFixed(0)
        }
        return calData
      }
      if (field === 'totalAvgViews') {
        let calData = 0;
        let count = 0
        this.youtubeAnalysisData.map(item => {
          calData += item.avg_views ? item.avg_views : 0
          if (item.avg_views > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (calData / count).toFixed(2)
        }
        return calData
      }
      if (field === 'totalAvgLikes') {
        let calData = 0;
        let count = 0
        this.youtubeAnalysisData.map(item => {
          calData += item.avg_likes ? item.avg_likes : 0
          if (item.avg_likes > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (calData / count).toFixed(2)
        }
        return calData
      }
      if (field === 'totalAvgComments') {
        let calData = 0;
        let count = 0
        this.youtubeAnalysisData.map(item => {
          calData += item.avg_comments ? item.avg_comments : 0
          if (item.avg_comments > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (calData / count).toFixed(2)
        }
        return calData
      }
      if (field === 'totalEngagementRate') {
        let calData = 0;
        let count = 0
        this.youtubeAnalysisData.map(item => {
          calData += item.new_engagement_rate ? Number(item.new_engagement_rate) : 0
          if (item.new_engagement_rate > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (calData / count).toFixed(2)
        }
        return calData
      }
      if (field === 'totalEngagementRateView') {
        let calData = 0;
        let count = 0
        this.youtubeAnalysisData.map(item => {
          calData += item.new_engagement_rate_view ? item.new_engagement_rate_view : 0
          if (item.new_engagement_rate_view > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (calData / count).toFixed(2)
        }
        return calData
      }
      if (field === 'totalEngagementRateSd') {
        let calData = 0;
        let count = 0
        this.youtubeAnalysisData.map(item => {
          calData += item.engagement_rate_sd ? item.engagement_rate_sd : 0
          if (item.engagement_rate_sd > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (calData / count).toFixed(2)
        }
        return calData
      }
      if (field === 'totalEngagementRateSd') {
        let calData = 0;
        let count = 0
        this.youtubeAnalysisData.map(item => {
          calData += item.engagement_rate_sd ? item.engagement_rate_sd : 0
          if (item.engagement_rate_sd > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (calData / count).toFixed(2)
        }
        return calData
      }
      if (field === 'totalMedianEngagementRate') {
        let calData = 0;
        let count = 0
        this.youtubeAnalysisData.map(item => {
          calData += item.median_engagement_rate ? item.median_engagement_rate : 0
          if (item.median_engagement_rate > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (calData / count).toFixed(2)
        }
        return calData
      }
    },
    calXHSTotal(field) {
      if (field === 'totalOutreach') {
        let outreach = 0;
        let count = 0
        this.xhsAnalysisData.map(item => {
          outreach += item.outreach ? item.outreach : 0
          if (item.outreach > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (outreach / count).toFixed(0)
        }
        return outreach
      }
      if (field === 'totalLikes') {
        let calData = 0;
        let count = 0
        this.xhsAnalysisData.map(item => {
          calData += item.like_count ? item.like_count : 0
          if (item.like_count > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (calData / count).toFixed(0)
        }
        return calData
      }
      if (field === 'totalComments') {
        let calData = 0;
        let count = 0
        this.xhsAnalysisData.map(item => {
          calData += item.comment_count ? item.comment_count : 0
          if (item.comment_count > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (calData / count).toFixed(0)
        }
        return calData
      }
      if (field === 'totalViews') {
        let calData = 0;
        let count = 0
        this.xhsAnalysisData.map(item => {
          calData += item.views ? item.views : 0
          if (item.views > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (calData / count).toFixed(0)
        }
        return calData
      }
      if (field === 'totalShares') {
        let calData = 0;
        let count = 0
        this.xhsAnalysisData.map(item => {
          calData += item.shares ? item.shares : 0
          if (item.shares > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (calData / count).toFixed(0)
        }
        return calData
      }
      if (field === 'totalBookmarks') {
        let calData = 0;
        let count = 0
        this.xhsAnalysisData.map(item => {
          calData += item.bookmarks ? item.bookmarks : 0
          if (item.bookmarks > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (calData / count).toFixed(0)
        }
        return calData
      }
      if (field === 'totalInteractions') {
        let calData = 0;
        let count = 0
        this.xhsAnalysisData.map(item => {
          calData += item.interactions ? item.interactions : 0
          if (item.interactions > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (calData / count).toFixed(0)
        }
        return calData
      }
    },
    calFbTotal(field) {
      if (field === 'totalOutreach') {
        let outreach = 0;
        let count = 0
        this.fbAnalysisData.map(item => {
          outreach += item.outreach ? item.outreach : 0
          if (item.outreach > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (outreach / count).toFixed(0)
        }
        return outreach
      }
      if (field === 'totalLikes') {
        let calData = 0;
        let count = 0
        this.fbAnalysisData.map(item => {
          calData += item.like_count ? item.like_count : 0
          if (item.like_count > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (calData / count).toFixed(0)
        }
        return calData
      }
      if (field === 'totalComments') {
        let calData = 0;
        let count = 0
        this.fbAnalysisData.map(item => {
          calData += item.comment_count ? item.comment_count : 0
          if (item.comment_count > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (calData / count).toFixed(0)
        }
        return calData
      }
      if (field === 'totalViews') {
        let calData = 0;
        let count = 0
        this.fbAnalysisData.map(item => {
          calData += item.views ? item.views : 0
          if (item.views > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (calData / count).toFixed(0)
        }
        return calData
      }
      if (field === 'totalShares') {
        let calData = 0;
        let count = 0
        this.fbAnalysisData.map(item => {
          calData += item.shares ? item.shares : 0
          if (item.shares > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (calData / count).toFixed(0)
        }
        return calData
      }
      if (field === 'totalBookmarks') {
        let calData = 0;
        let count = 0
        this.fbAnalysisData.map(item => {
          calData += item.bookmarks ? item.bookmarks : 0
          if (item.bookmarks > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (calData / count).toFixed(0)
        }
        return calData
      }
      if (field === 'totalInteractions') {
        let calData = 0;
        let count = 0
        this.fbAnalysisData.map(item => {
          calData += item.interactions ? item.interactions : 0
          if (item.interactions > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (calData / count).toFixed(0)
        }
        return calData
      }
    },
    calPostAvg(field) {
      if (field === 'totalOutreach') {
        let outreach = 0;
        let count = 0
        this.selectedPostAnalysis.map(item => {
          outreach += item.outreach ? item.outreach : 0
          if (item.outreach > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (outreach / count).toFixed(0)
        }
        return outreach
      }
      if (field === 'totalReach') {
        let reach = 0;
        let count = 0
        this.selectedPostAnalysis.map(item => {
          reach += item.reach ? item.reach : 0
          if (item.reach > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (reach / count).toFixed(0)
        }
        return reach
      }
      if (field === 'totalImpressions') {
        let impressions = 0;
        let count = 0
        this.selectedPostAnalysis.map(item => {
          impressions += item.impressions ? item.impressions : 0
          if (item.impressions > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (impressions / count).toFixed(0)
        }
        return impressions
      }
      if (field === 'totalLikes') {
        let likes = 0;
        let count = 0
        this.selectedPostAnalysis.map(item => {
          likes += item.likes ? item.likes : 0
          if (item.likes > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (likes / count).toFixed(0)
        }
        return likes
      }
      if (field === 'totalShares') {
        let shares = 0
        let count = 0
        this.selectedPostAnalysis.map(item => {
          shares += item.shares ? item.shares : 0
          if (item.shares > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (shares / count).toFixed(0)
        }
        return shares
      }
      if (field === 'totalComments') {
        let comments = 0;
        let count = 0
        this.selectedPostAnalysis.map(item => {
          comments += item.comments ? item.comments : 0
          if (item.comments > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (comments / count).toFixed(0)
        }
        return comments
      }
      if (field === 'totalSaved') {
        let saved = 0;
        let count = 0
        this.selectedPostAnalysis.map(item => {
          saved += item.saved ? item.saved : 0
          if (item.saved > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (saved / count).toFixed(0)
        }
        return saved
      }
      if (field === 'totalInteractions') {
        let interactions = 0;
        let count = 0;
        this.selectedPostAnalysis.map(item => {
          interactions += item.interactions ? item.interactions : 0
          if (item.interactions > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (interactions / count).toFixed(0)
        }
        return interactions
      }
      if (field === 'totalViews') {
        let views = 0;
        let count = 0;
        this.selectedPostAnalysis.map(item => {
          views += item.views ? item.views : 0
          if (item.views > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (views / count).toFixed(0)
        }
        return views
      }
      if (field === 'totalEngagementRate') {
        let engTotal = 0;
        let count = 0;
        this.selectedPostAnalysis.map(item => {
          engTotal += item.new_engagement_rate ? item.new_engagement_rate : 0
          if (item.new_engagement_rate > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (engTotal / count).toFixed(2)
        }
        return engTotal
      }
      if (field === 'totalEngagementRateView') {
        let engTotal = 0;
        let count = 0;
        this.selectedPostAnalysis.map(item => {
          engTotal += item.new_engagement_rate_view ? item.new_engagement_rate_view : 0
          if (item.new_engagement_rate_view > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (engTotal / count).toFixed(2)
        }
        return engTotal
      }
      if (field === 'totalEngagementRateReach') {
        let engTotal = 0;
        let count = 0;
        this.selectedPostAnalysis.map(item => {
          engTotal += item.engagement_rate_reach ? item.engagement_rate_reach : 0
          if (item.engagement_rate_reach > 0) {
            count += 1
          }
        })
        if (count > 0 && engTotal > 0) {
          return (engTotal / count).toFixed(2)
        }
        return engTotal
      }
      if (field === 'totalEngRateSd') {
        let engTotal = 0;
        let count = 0;
        this.selectedPostAnalysis.map(item => {
          engTotal += item.engagement_rate_sd ? Number(item.engagement_rate_sd) : 0
          if (Number(item.engagement_rate_sd) > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (engTotal / count).toFixed(2)
        }
        return engTotal
      }
      if (field === 'totalMedianEngRate') {
        let engTotal = 0;
        let count = 0;
        this.selectedPostAnalysis.map(item => {
          engTotal += item.median_engagement_rate ? item.median_engagement_rate : 0
          if (item.median_engagement_rate > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (engTotal / count).toFixed(2)
        }
        return engTotal
      }
      if (field === 'totalAvgLikes') {
        let engTotal = 0;
        let count = 0;
        this.selectedPostAnalysis.map(item => {
          engTotal += item.avg_likes ? item.avg_likes : 0
          if (item.avg_likes > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (engTotal / count).toFixed(2)
        }
        return engTotal
      }
      if (field === 'totalAvgComments') {
        let engTotal = 0;
        let count = 0;
        this.selectedPostAnalysis.map(item => {
          engTotal += item.avg_comments ? item.avg_comments : 0
          if (item.avg_comments > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (engTotal / count).toFixed(2)
        }
        return engTotal
      }
      if (field === 'totalAvgViews') {
        let engTotal = 0;
        let count = 0;
        this.selectedPostAnalysis.map(item => {
          engTotal += item.avg_views ? item.avg_views : 0
          if (item.avg_views > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (engTotal / count).toFixed(2)
        }
        return engTotal
      }
    },
    calStoryAvg(field) {
      if (field === 'totalOutreach') {
        let outreach = 0;
        let count = 0
        this.selectedStoryAnalysis.map(item => {
          outreach += item.outreach ? item.outreach : 0
          if (item.outreach > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (outreach / count).toFixed(0)
        }
        return outreach
      }
      if (field === 'totalReach') {
        let reach = 0;
        let count = 0
        this.selectedStoryAnalysis.map(item => {
          reach += item.reach ? item.reach : 0
          if (item.reach > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (reach / count).toFixed(0)
        }
        return reach
      }
      if (field === 'totalImpressions') {
        let impressions = 0;
        let count = 0
        this.selectedStoryAnalysis.map(item => {
          impressions += item.impressions ? item.impressions : 0
          if (item.impressions > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (impressions / count).toFixed(0)
        }
        return impressions
      }
      if (field === 'totalReplies') {
        let replies = 0;
        let count = 0;
        this.selectedStoryAnalysis.map(item => {
          replies += item.replies ? item.replies : 0
          if (item.replies > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (replies / count).toFixed(0)
        }
        return replies
      }
      if (field === 'totalShares') {
        let shares = 0;
        let count = 0;
        this.selectedStoryAnalysis.map(item => {
          shares += item.shares ? item.shares : 0
          if (item.shares > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (shares / count).toFixed(0)
        }
        return shares
      }
      if (field === 'totalLinkClicks') {
        let linkClicks = 0;
        let count = 0
        this.selectedStoryAnalysis.map(item => {
          linkClicks += item.link_clicks ? item.link_clicks : 0
          if (item.link_clicks > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (linkClicks / count).toFixed(0)
        }
        return linkClicks
      }
      if (field === 'totalStickerTaps') {
        let stickerTaps = 0
        let count = 0
        this.selectedStoryAnalysis.map(item => {
          stickerTaps += item.sticker_taps ? item.sticker_taps : 0
          if (item.sticker_taps > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (stickerTaps / count).toFixed(0)
        }
        return stickerTaps
      }
      if (field === 'totalInteractions') {
        let interactions = 0;
        let count = 0;
        this.selectedStoryAnalysis.map(item => {
          interactions += item.interactions ? item.interactions : 0
          if (item.interactions > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (interactions / count).toFixed(0)
        }
        return interactions
      }
      if (field === 'totalAvgViews') {
        let calData = 0;
        let count = 0;
        this.selectedStoryAnalysis.map(item => {
          calData += item.avg_views ? item.avg_views : 0
          if (item.avg_views > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (calData / count).toFixed(0)
        }
        return calData
      }
      if (field === 'totalAvgReelPlays') {
        let calData = 0;
        let count = 0;
        this.selectedStoryAnalysis.map(item => {
          calData += item.avg_reels_plays ? item.avg_reels_plays : 0
          if (item.avg_reels_plays > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (calData / count).toFixed(0)
        }
        return calData
      }
    },
    calReelAvg(field) {
      if (field === 'totalOutreach') {
        let outreach = 0;
        let count = 0
        this.selectedReelAnalysis.map(item => {
          outreach += item.outreach ? item.outreach : 0
          if (item.outreach > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (outreach / count).toFixed(0)
        }
        return outreach
      }
      if (field === 'totalReach') {
        let reach = 0;
        let count = 0
        this.selectedReelAnalysis.map(item => {
          reach += item.reach ? item.reach : 0
          if (reach > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (reach / count).toFixed(0)
        }
        return reach
      }
      if (field === 'totalImpressions') {
        let impressions = 0;
        let count = 0
        this.selectedReelAnalysis.map(item => {
          impressions += item.impressions ? item.impressions : 0
          if (impressions > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (impressions / count).toFixed(0)
        }
        return impressions
      }
      if (field === 'totalLikes') {
        let likes = 0;
        let count = 0
        this.selectedReelAnalysis.map(item => {
          likes += item.likes ? item.likes : 0
          if (item.likes > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (likes / count).toFixed(0)
        }
        return likes
      }
      if (field === 'totalShares') {
        let shares = 0;
        let count = 0
        this.selectedReelAnalysis.map(item => {
          shares += item.shares ? item.shares : 0
          if (item.shares > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (shares / count).toFixed(0)
        }
        return shares
      }
      if (field === 'totalComments') {
        let comments = 0;
        let count = 0
        this.selectedReelAnalysis.map(item => {
          comments += item.comments ? item.comments : 0
          if (item.comments > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (comments / count).toFixed(0)
        }
        return comments
      }
      if (field === 'totalSaved') {
        let saved = 0;
        let count = 0
        this.selectedReelAnalysis.map(item => {
          saved += item.saved ? item.saved : 0
          if (item.saved > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (saved / count).toFixed(0)
        }
        return saved
      }
      if (field === 'totalInteractions') {
        let interactions = 0;
        let count = 0
        this.selectedReelAnalysis.map(item => {
          interactions += item.interactions ? item.interactions : 0
          if (item.interactions > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (interactions / count).toFixed(0)
        }
        return interactions
      }
      if (field === 'totalViews') {
        let views = 0;
        let count = 0
        this.selectedReelAnalysis.map(item => {
          views += item.views ? item.views : 0
          if (item.views > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (views / count).toFixed(0)
        }
        return views
      }
      if (field === 'totalEngagementRate') {
        let engRate = 0;
        let count = 0
        this.selectedReelAnalysis.map(item => {
          engRate += item.new_engagement_rate ? item.new_engagement_rate : 0
          if (item.new_engagement_rate > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (engRate / count).toFixed(2)
        }
        return engRate
      }
      if (field === 'totalEngagementRateView') {
        let engRate = 0
        let count = 0
        this.selectedReelAnalysis.map(item => {
          engRate += item.new_engagement_rate_view ? item.new_engagement_rate_view : 0
          if (item.new_engagement_rate_view > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (engRate / count).toFixed(2)
        }
        return engRate
      }
      if (field === 'totalInteractionRatePlays') {
        let engRate = 0;
        let count = 0
        this.selectedReelAnalysis.map(item => {
          engRate += item.interaction_rate_plays ? item.interaction_rate_plays : 0
          if (item.interaction_rate_plays > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (engRate / count).toFixed(2)
        }
        return engRate
      }
      if (field === 'totalEngagementRateReach') {
        let engRate = 0;
        let count = 0
        this.selectedReelAnalysis.map(item => {
          engRate += item.engagement_rate_reach ? item.engagement_rate_reach : 0
          if (item.engagement_rate_reach > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (engRate / count).toFixed(2)
        }
        return engRate
      }
      if (field === 'totalEngRateSd') {
        let engRate = 0;
        let count = 0
        this.selectedReelAnalysis.map(item => {
          engRate += item.engagement_rate_sd ? Number(item.engagement_rate_sd) : 0
          if (item.engagement_rate_sd > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (engRate / count).toFixed(2)
        }
        return engRate
      }
      if (field === 'totalMedianEngRate') {
        let engRate = 0;
        let count = 0
        this.selectedReelAnalysis.map(item => {
          engRate += item.median_engagement_rate ? item.median_engagement_rate : 0
          if (item.median_engagement_rate > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (engRate / count).toFixed(2)
        }
        return engRate
      }
      if (field === 'totalMedianEngRate') {
        let engRate = 0;
        let count = 0
        this.selectedReelAnalysis.map(item => {
          engRate += item.median_engagement_rate ? item.median_engagement_rate : 0
          if (item.median_engagement_rate > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (engRate / count).toFixed(2)
        }
        return engRate
      }
      if (field === 'totalAvgLikes') {
        let engRate = 0;
        let count = 0
        this.selectedReelAnalysis.map(item => {
          engRate += item.avg_likes ? item.avg_likes : 0
          if (item.avg_likes > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (engRate / count).toFixed(2)
        }
        return engRate
      }
      if (field === 'totalAvgComments') {
        let engRate = 0;
        let count = 0
        this.selectedReelAnalysis.map(item => {
          engRate += item.avg_comments ? item.avg_comments : 0
          if (item.avg_comments > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (engRate / count).toFixed(2)
        }
        return engRate
      }
      if (field === 'totalAvgViews') {
        let engRate = 0;
        let count = 0
        this.selectedReelAnalysis.map(item => {
          engRate += item.avg_views ? item.avg_views : 0
          if (item.avg_views > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (engRate / count).toFixed(2)
        }
        return engRate
      }
      if (field === 'totalReelPlays') {
        let engRate = 0;
        let count = 0
        this.selectedReelAnalysis.map(item => {
          engRate += item.avg_reels_plays ? item.avg_reels_plays : 0
          if (item.avg_reels_plays > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (engRate / count).toFixed(2)
        }
        return engRate
      }
    },
    calTikTokAvg(field) {
      if (field === 'totalOutreach') {
        let outreach = 0;
        let count = 0
        this.selectedTikTokAnalysis.map(item => {
          outreach += item.outreach ? item.outreach : 0
          if (item.outreach > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (outreach / count).toFixed(0)
        }
        return outreach
      }
      if (field === 'totalWatches') {
        let watches = 0;
        let count = 0
        this.selectedTikTokAnalysis.map(item => {
          watches += item.watches ? campaignHelper.formatWatchTime(item.watches) : 0
          if (item.watches) {
            count += 1
          }
        })
        if (count > 0) {
          return (watches / count).toFixed(2) + 's'
        }
        return `${watches}s`
      }
      if (field === 'totalLikes') {
        let likes = 0;
        let count = 0
        this.selectedTikTokAnalysis.map(item => {
          likes += item.likes ? item.likes : 0
          if (item.likes > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (likes / count).toFixed(0)
        }
        return likes
      }
      if (field === 'totalComments') {
        let comments = 0;
        let count = 0
        this.selectedTikTokAnalysis.map(item => {
          comments += item.comments ? item.comments : 0
          if (item.comments > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (comments / count).toFixed(0)
        }
        return comments
      }
      if (field === 'totalShares') {
        let shares = 0;
        let count = 0
        this.selectedTikTokAnalysis.map(item => {
          shares += item.shares ? item.shares : 0
          if (item.shares > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (shares / count).toFixed(0)
        }
        return shares
      }
      if (field === 'totalBookmarks') {
        let saved = 0;
        let count = 0
        this.selectedTikTokAnalysis.map(item => {
          saved += item.saved ? item.saved : 0
          if (item.saved > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (saved / count).toFixed(0)
        }
        return saved
      }
      if (field === 'totalInteractions') {
        let interactions = 0;
        let count = 0
        this.selectedTikTokAnalysis.map(item => {
          interactions += item.interactions ? item.interactions : 0
          if (item.interactions > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (interactions / count).toFixed(0)
        }
        return interactions
      }
      if (field === 'totalViews') {
        let views = 0;
        let count = 0
        this.selectedTikTokAnalysis.map(item => {
          views += item.views ? item.views : 0
          if (item.views > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (views / count).toFixed(0)
        }
        return views
      }
      if (field === 'totalReach') {
        let reach = 0;
        let count = 0
        this.selectedTikTokAnalysis.map(item => {
          reach += item.reach ? item.reach : 0
          if (item.reach > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (reach / count).toFixed(0)
        }
        return reach
      }
      if (field === 'totalImpressions') {
        let impressions = 0;
        let count = 0
        this.selectedTikTokAnalysis.map(item => {
          impressions += item.impressions ? item.impressions : 0
          if (item.impressions > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (impressions / count).toFixed(0)
        }
        return impressions
      }
      if (field === 'totalAvgViews') {
        let calData = 0;
        let count = 0
        this.selectedTikTokAnalysis.map(item => {
          calData += item.avg_views ? item.avg_views : 0
          if (item.avg_views > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (calData / count).toFixed(2)
        }
        return calData
      }
      if (field === 'totalAvgLikes') {
        let calData = 0;
        let count = 0
        this.selectedTikTokAnalysis.map(item => {
          calData += item.avg_likes ? item.avg_likes : 0
          if (item.avg_likes > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (calData / count).toFixed(2)
        }
        return calData
      }
      if (field === 'totalAvgComments') {
        let calData = 0;
        let count = 0
        this.selectedTikTokAnalysis.map(item => {
          calData += item.avg_comments ? item.avg_comments : 0
          if (item.avg_comments > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (calData / count).toFixed(2)
        }
        return calData
      }
      if (field === 'totalAvgSaves') {
        let calData = 0;
        let count = 0
        this.selectedTikTokAnalysis.map(item => {
          calData += item.avg_saves ? item.avg_saves : 0
          if (item.avg_saves > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (calData / count).toFixed(2)
        }
        return calData
      }
      if (field === 'totalAvgShares') {
        let calData = 0;
        let count = 0
        this.selectedTikTokAnalysis.map(item => {
          calData += item.avg_saves ? item.avg_saves : 0
          if (item.avg_saves > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (calData / count).toFixed(2)
        }
        return calData
      }
      if (field === 'totalEngagementRate') {
        let engRate = 0;
        let count = 0
        this.selectedTikTokAnalysis.map(item => {
          engRate += item.new_engagement_rate ? item.new_engagement_rate : 0
          if (item.new_engagement_rate > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (engRate / count).toFixed(2)
        }
        return engRate
      }
      if (field === 'totalEngagementRateView') {
        let engRate = 0;
        let count = 0
        this.selectedTikTokAnalysis.map(item => {
          engRate += item.new_engagement_rate_view ? item.new_engagement_rate_view : 0
          if (item.new_engagement_rate_view > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (engRate / count).toFixed(2)
        }
        return engRate
      }
      if (field === 'totalInteractionRatePlays') {
        let engRate = 0;
        let count = 0
        this.selectedTikTokAnalysis.map(item => {
          engRate += item.interaction_rate_plays ? item.interaction_rate_plays : 0
          if (item.interaction_rate_plays > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (engRate / count).toFixed(0)
        }
        return engRate
      }
      if (field === 'totalEngRateTotalViewers') {
        let engRate = 0;
        let count = 0
        this.selectedTikTokAnalysis.map(item => {
          engRate += item.eng_rate_total_viewers ? item.eng_rate_total_viewers : 0
          if (item.eng_rate_total_viewers > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (engRate / count).toFixed(2)
        }
        return engRate
      }
      if (field === 'totalEngRateSd') {
        let engRate = 0;
        let count = 0
        this.selectedTikTokAnalysis.map(item => {
          engRate += item.engagement_rate_sd ? item.engagement_rate_sd : 0
          if (item.engagement_rate_sd > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (engRate / count).toFixed(2)
        }
        return engRate
      }
      if (field === 'totalMedianEngRateSd') {
        let engRate = 0;
        let count = 0
        this.selectedTikTokAnalysis.map(item => {
          engRate += item.median_engagement_rate ? item.median_engagement_rate : 0
          if (item.median_engagement_rate > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (engRate / count).toFixed(2)
        }
        return engRate
      }
      if (field === 'totalWatchedFullVideo') {
        let engRate = 0;
        let count = 0
        this.selectedTikTokAnalysis.map(item => {
          engRate += item.watchedFullVideo ? item.watchedFullVideo : 0
          if (item.watchedFullVideo > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (engRate / count).toFixed(2)
        }
        return engRate
      }
    },
    calYoutubeAvg(field) {
      if (field === 'totalOutreach') {
        let outreach = 0;
        let count = 0
        this.selectedYoutubeAnalysis.map(item => {
          outreach += item.outreach ? item.outreach : 0
          if (item.outreach > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (outreach / count).toFixed(0)
        }
        return outreach
      }
      if (field === 'totalViews') {
        let calData = 0;
        let count = 0
        this.selectedYoutubeAnalysis.map(item => {
          calData += item.views ? item.views : 0
          if (item.views > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (calData / count).toFixed(0)
        }
        return calData
      }
      if (field === 'totalLikes') {
        let calData = 0;
        let count = 0
        this.selectedYoutubeAnalysis.map(item => {
          calData += item.likes ? item.likes : 0
          if (item.likes > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (calData / count).toFixed(0)
        }
        return calData
      }
      if (field === 'totalComments') {
        let calData = 0;
        let count = 0
        this.selectedYoutubeAnalysis.map(item => {
          calData += item.comments ? item.comments : 0
          if (item.comments > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (calData / count).toFixed(0)
        }
        return calData
      }
      if (field === 'totalInteractions') {
        let calData = 0;
        let count = 0
        this.selectedYoutubeAnalysis.map(item => {
          calData += item.interactions ? item.interactions : 0
          if (item.interactions > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (calData / count).toFixed(0)
        }
        return calData
      }
      if (field === 'totalAvgViews') {
        let calData = 0;
        let count = 0
        this.selectedYoutubeAnalysis.map(item => {
          calData += item.avg_views ? item.avg_views : 0
          if (item.avg_views > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (calData / count).toFixed(2)
        }
        return calData
      }
      if (field === 'totalAvgLikes') {
        let calData = 0;
        let count = 0
        this.selectedYoutubeAnalysis.map(item => {
          calData += item.avg_likes ? item.avg_likes : 0
          if (item.avg_likes > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (calData / count).toFixed(2)
        }
        return calData
      }
      if (field === 'totalAvgComments') {
        let calData = 0;
        let count = 0
        this.selectedYoutubeAnalysis.map(item => {
          calData += item.avg_comments ? item.avg_comments : 0
          if (item.avg_comments > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (calData / count).toFixed(2)
        }
        return calData
      }
      if (field === 'totalEngagementRate') {
        let calData = 0;
        let count = 0
        this.selectedYoutubeAnalysis.map(item => {
          calData += item.new_engagement_rate ? Number(item.new_engagement_rate) : 0
          if (item.new_engagement_rate > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (calData / count).toFixed(2)
        }
        return calData
      }
      if (field === 'totalEngagementRateView') {
        let calData = 0;
        let count = 0
        this.selectedYoutubeAnalysis.map(item => {
          calData += item.new_engagement_rate_view ? item.new_engagement_rate_view : 0
          if (item.new_engagement_rate_view > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (calData / count).toFixed(2)
        }
        return calData
      }
      if (field === 'totalEngagementRateSd') {
        let calData = 0;
        let count = 0
        this.selectedYoutubeAnalysis.map(item => {
          calData += item.engagement_rate_sd ? item.engagement_rate_sd : 0
          if (item.engagement_rate_sd > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (calData / count).toFixed(2)
        }
        return calData
      }
      if (field === 'totalEngagementRateSd') {
        let calData = 0;
        let count = 0
        this.selectedYoutubeAnalysis.map(item => {
          calData += item.engagement_rate_sd ? item.engagement_rate_sd : 0
          if (item.engagement_rate_sd > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (calData / count).toFixed(2)
        }
        return calData
      }
      if (field === 'totalMedianEngagementRate') {
        let calData = 0;
        let count = 0
        this.selectedYoutubeAnalysis.map(item => {
          calData += item.median_engagement_rate ? item.median_engagement_rate : 0
          if (item.median_engagement_rate > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (calData / count).toFixed(2)
        }
        return calData
      }
    },
    calXhsAvg(field) {
      if (field === 'totalOutreach') {
        let outreach = 0;
        let count = 0
        this.selectedXhsAnalysis.map(item => {
          outreach += item.outreach ? item.outreach : 0
          if (item.outreach > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (outreach / count).toFixed(0)
        }
        return outreach
      }
      if (field === 'totalLikes') {
        let calData = 0;
        let count = 0
        this.selectedXhsAnalysis.map(item => {
          calData += item.like_count ? item.like_count : 0
          if (item.like_count > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (calData / count).toFixed(0)
        }
        return calData
      }
      if (field === 'totalComments') {
        let calData = 0;
        let count = 0
        this.selectedXhsAnalysis.map(item => {
          calData += item.comment_count ? item.comment_count : 0
          if (item.comment_count > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (calData / count).toFixed(0)
        }
        return calData
      }
      if (field === 'totalViews') {
        let calData = 0;
        let count = 0
        this.selectedXhsAnalysis.map(item => {
          calData += item.views ? item.views : 0
          if (item.views > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (calData / count).toFixed(0)
        }
        return calData
      }
      if (field === 'totalShares') {
        let calData = 0;
        let count = 0
        this.selectedXhsAnalysis.map(item => {
          calData += item.shares ? item.shares : 0
          if (item.shares > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (calData / count).toFixed(0)
        }
        return calData
      }
      if (field === 'totalBookmarks') {
        let calData = 0;
        let count = 0
        this.selectedXhsAnalysis.map(item => {
          calData += item.bookmarks ? item.bookmarks : 0
          if (item.bookmarks > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (calData / count).toFixed(0)
        }
        return calData
      }
      if (field === 'totalInteractions') {
        let calData = 0;
        let count = 0
        this.selectedXhsAnalysis.map(item => {
          calData += item.interactions ? item.interactions : 0
          if (item.interactions > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (calData / count).toFixed(0)
        }
        return calData
      }
    },
    calFbAvg(field) {
      if (field === 'totalOutreach') {
        let outreach = 0;
        let count = 0
        this.selectedFbAnalysis.map(item => {
          outreach += item.outreach ? item.outreach : 0
          if (item.outreach > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (outreach / count).toFixed(0)
        }
        return outreach
      }
      if (field === 'totalLikes') {
        let calData = 0;
        let count = 0
        this.selectedFbAnalysis.map(item => {
          calData += item.like_count ? item.like_count : 0
          if (item.like_count > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (calData / count).toFixed(0)
        }
        return calData
      }
      if (field === 'totalComments') {
        let calData = 0;
        let count = 0
        this.selectedFbAnalysis.map(item => {
          calData += item.comment_count ? item.comment_count : 0
          if (item.comment_count > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (calData / count).toFixed(0)
        }
        return calData
      }
      if (field === 'totalViews') {
        let calData = 0;
        let count = 0
        this.selectedFbAnalysis.map(item => {
          calData += item.views ? item.views : 0
          if (item.views > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (calData / count).toFixed(0)
        }
        return calData
      }
      if (field === 'totalShares') {
        let calData = 0;
        let count = 0
        this.selectedFbAnalysis.map(item => {
          calData += item.shares ? item.shares : 0
          if (item.shares > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (calData / count).toFixed(0)
        }
        return calData
      }
      if (field === 'totalBookmarks') {
        let calData = 0;
        let count = 0
        this.selectedFbAnalysis.map(item => {
          calData += item.bookmarks ? item.bookmarks : 0
          if (item.bookmarks > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (calData / count).toFixed(0)
        }
        return calData
      }
      if (field === 'totalInteractions') {
        let calData = 0;
        let count = 0
        this.selectedFbAnalysis.map(item => {
          calData += item.interactions ? item.interactions : 0
          if (item.interactions > 0) {
            count += 1
          }
        })
        if (count > 0) {
          return (calData / count).toFixed(0)
        }
        return calData
      }
    },
    openPostAnalysisAvgModal() {
      this.avgPostAnalysisDialog = true
    },
    openStoryAnalysisAvgModal() {
      this.avgStoryAnalysisDialog = true
    },
    openReelAnalysisAvgModal() {
      this.avgReelAnalysisDialog = true
    },
    openTikTokAnalysisAvgModal() {
      this.avgTiktokAnalysisDialog = true
    },
    openYoutubeAnalysisAvgModal() {
      this.avgYoutubeAnalysisDialog = true
    },
    openXhsAnalysisAvgModal() {
      this.avgXhsAnalysisDialog = true
    },
    openFbAnalysisAvgModal() {
      this.avgFbAnalysisDialog = true
    },
    resetAnalysisData() {
      this.selectedPostAnalysis = []
      this.selectedStoryAnalysis = []
      this.selectedReelAnalysis = []
      this.selectedTikTokAnalysis = []
      this.selectedYoutubeAnalysis = []
      this.selectedXhsAnalysis = []
      this.selectedFbAnalysis = []
    },
    storeStatsData(data) {
      campaignAPIs
        .storeStatsData(data)
        .then(response => {
        })
        .catch(error => {
          // Request failed.
          console.log('error', error);
          this.$swal({
            text: error,
            type: 'error'
          });
        });
    }
  }
}
</script>
<style scoped>
  .statistics-analysis-table .vs-sign {
    /* text-align: center; */
    margin: 5px 0;
    font-weight: 500;
  }
  .statistics-analysis-table .row-content {
    background-color: #f3f3f3;
  }
</style>



// WEBPACK FOOTER //
// DataTable.vue?40ac93ff